import React, { useState, useRef, useEffect, useMemo } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  DatePicker,
  Select,
  message,
  Checkbox,
  Switch,
  Upload,
  Modal,
  TimePicker,
  Divider,
  Radio,
  Spin,
} from "antd";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import Button from "atoms/Button";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import moment from "moment";
import {
  NON_EMPTY_REGEX,
  EMAIL_REGEX,
  STATUS_CODE,
  countryList,
  CompetencyQC,
  ServiceLine,
  SubServiceLine,
  CompetencyRole,
  IndustryRole,
  Industry,
  Grade,
  Greetings,
  Degree,
  ProfessionalCertification,
  CountryCompany,
  Sector,
  SUPERVISOR,
  AwardList,
  MANAGER,
  secondaryIndustry,
  ContractingCompany,
  RegionalCometencyRole,
  countryNameToCode,
} from "common/Constants";
import SelectTable from "../molecules/SelectTable";
import InReview from "../organisms/FormReview";
import { bindActionCreators } from "redux";
import {
  getAllDepartmentList,
  getLocations,
  getClientid,
  getLeaveCategoryList,
  getRoleList,
  getUserList,
  getBandList,
  getSupervisorList,
  getChargeoutRatesList
} from "redux/selectors";
import { setUserList, setRoleList } from "redux/actions";
import {
  chain,
  concat,
  filter,
  find,
  flatMap,
  get,
  includes,
  intersectionBy,
  isEmpty,
} from "lodash";
import { useDropzone } from "react-dropzone";
import StepsProgress from "./StepsProgress";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FormModal from "./FormModal";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import axios from "axios";
import { allowOnlyNumbers } from "utils/functions";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import Table from "atoms/Table";
import { ReactComponent as DeleteIcon } from "../assets/delete_Icon.svg";
import { UploadOutlined } from "@ant-design/icons";
import Confirm from "../../src/assets/Confirm.svg";
import { EyeOutlined } from "@ant-design/icons";
import { getUserInfo } from "redux/selectors";
import { useSelector } from "react-redux";
import { ReactComponent as TrashDelete } from "../assets/Trash_Full.svg";
import dayjs from "dayjs";
import { uniqBy } from "lodash";


const StyledModal = styled(Form)`
  .ant-modal-header {
    border-bottom: none;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .ant-modal-title {
    font-weight: 600;
    text-align: center;
    font-size: 24px;
    color: #1b1b1b;
  }
  .anticon {
    color: #000000;
    width: 14px;
    height: 14px;
  }
  .ant-modal-close {
    margin-top: 14px;
  }
  .ant-modal-body {
    padding-top: 0px;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-form-item-label {
    font-weight: 500;
  }
  .ant-picker,
  .ant-input-number {
    width: 100%;
  }
  .ant-btn-text:focus,
  .ant-btn-text:hover {
    background: #26a4ff;
    color: #ffffff;
  }
  .check-box {
    font-size: 14px;
    font-weight: 500;
  }
  .add_employee_col {
    padding: 5px;
  }
  .review_data_box_container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-flow: wrap;
  }
  .review_data_box {
    width: auto;
    padding: 1rem 1.4rem;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000015;
  }
  .review_datas {
    display: flex;
    justify-content: space-between;
    text-align: left;
    gap: 1rem;
  }
  .review_datas_key {
    text-align: left;
    font: normal normal bold 16px/20px Circular Std;
    letter-spacing: 0px;
    color: #000000;
  }
  .review_datas_value {
    text-align: left;
    font: normal normal normal 16px/20px Circular Std;
    letter-spacing: 0px;
    color: #000000;
  }
  .review_title {
    border-bottom: 1.5px solid #d9d9d9;
    width: fit-content;
    text-align: left;
    font: normal normal Bold 18px/20px Circular Std;
    letter-spacing: 0px;
    color: #000000;
  }
`;
const StyledButton = styled(Button)`
  background: #26a4ff;
  border-radius: 5px;
  color: #ffffff;
  width: 100px;
`;

const StyleRow = styled(Row)`
  padding: 10px;
  box-shadow: 0px 3px 6px #00000015;
  .ant-form-item-label {
    text-align: left;
  }
  .ant-picker {
    width: 100% !important;
  }
  .ant-upload.ant-upload-select {
    width: 100% !important;
    color: #397ff4 !important;
    .ant-btn > span {
      display: inline-block;
      color: #397ff4;
    }
    button,
    html [type="button"],
    [type="reset"],
    [type="submit"] {
      background: #f2f2f2;
    }
    /* .anticon svg {
    color: #397FF4;
} */
    .ant-upload-list-picture .ant-upload-list-item,
    .ant-upload-list-picture-card .ant-upload-list-item {
      height: 40px;
    }
    .ant-upload-list-text .ant-upload-list-item-name,
    .ant-upload-list-picture .ant-upload-list-item-name {
      color: #397ff4;
    }
  }

  .ant-checkbox.ant-checkbox-checked {
    .ant-checkbox-inner {
      background-color: #02b209 !important;
      border-color: #02b209 !important;
    }
  }
`;

const StyledDropzone = styled.div`
  text-align: center;
  width: 100%;
  height: 40px;
  background: #e3e3e3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  p {
    padding-top: 10px;
  }
`;

const StyledFormModal = styled(Modal)`
  .ant-modal-header {
    border-radius: 10px;
    border-bottom: none;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .ant-modal-title {
    font-weight: bold;
    font-weight: 1.2rem;
  }
  .anticon {
    color: #000000;
    width: 14px;
    height: 14px;
  }
  .ant-modal-close {
    margin-top: 14px;
  }
  .ant-modal-body {
    padding-top: 0px;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-form-item-label {
    font-weight: 500;
  }
  .ant-picker,
  .ant-input-number {
    width: 100%;
  }
  .ant-btn-text:focus,
  .ant-btn-text:hover {
    background: #26a4ff;
    color: #ffffff;
  }
  .ant-modal-content {
    border-radius: 10px;
  }
`;

const GreenRadioGroup = styled(Radio.Group)`
  .ant-radio-wrapper {
    align-items: flex-start;
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #52c41a; /* Green border */
  }

  .ant-radio-inner::after {
    background-color: #52c41a !important; /* Green dot */
  }

  .ant-radio:hover .ant-radio-inner {
    border-color: #52c41a;
  }

  .ant-radio-checked .ant-radio-inner:hover {
    border-color: #52c41a;
  }
`;
const CircleLoader = () => (
  <span
    style={{
      display: "inline-block",
      width: 18,
      height: 18,
      marginLeft: 8,
      verticalAlign: "middle",
    }}
  >
    <span
      style={{
        display: "block",
        width: 18,
        height: 18,
        border: "2px solid #222",
        borderTop: "2px solid transparent",
        borderRadius: "50%",
        animation: "circle-spin 0.7s linear infinite",
      }}
    />
    <style>
      {`
        @keyframes circle-spin {
          0% { transform: rotate(0deg);}
          100% { transform: rotate(360deg);}
        }
      `}
    </style>
  </span>
);

function generateUniqueId() {
  // Generate a random number and convert it to base 36 (numbers + letters)
  const randomNumber = Math.random().toString(36).substr(2, 9);

  // Get the current timestamp
  const timestamp = Date.now();

  // Combine the random number with the timestamp
  const uniqueId = randomNumber + timestamp;

  return uniqueId;
}

export const handleCertificationChange = (value, setShowOtherCertification) => {
  setShowOtherCertification(value === "Others");
};

function AddEmployee({
  closeModal,
  getEmployeeList,
  EmployeeList,
  ClientId,
  updateUserList,
  roleList,
  bandList,
  locationList,
  userList,
  supervisorList,
  selectedDetails = {},
  defaultStep = 0,
  saveRoleList,
  leaveCategoryList
}) {
  const filteredLocation =
    locationList?.filter((item) => item.login_from_anywhere !== 1) || [];
  const roleOptions = roleList?.filter((role) => role?.display === 1)
  const [showLoader, toggleLoader] = useState(false);
  const [filename, setFileName] = useState("");
  const [form] = Form.useForm();
  const { Option } = Select;
  const containerRef = useRef(null);
  const [profileUploaded, setProfileUploaded] = useState(false);
  const [uniqueId, setUniqueId] = useState(generateUniqueId());
  const [storeId, setStoreId] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState([]);
  const [baseLocation, setBaseLocation] = useState("");
  const [selectAllRoleChecked, setSelectAllRoleChecked] = useState(false);
  const [serialNo, setSerialNo] = useState("");
  const [showOtherCertification, setShowOtherCertification] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const initializedRef = useRef(false);
  const [formValues, setFormValues] = useState({});
  const [isHistory, setIsHistory] = useState(false);
  const [gradeMap, setGradeMap] = useState({});
  const [filteredLocationsData, setFilteredLocationsData] = React.useState([]);

  const [data, setData] = useState([
    {
      key: 1,
      orgLevel: "",
      areaofwork: "",
      subareaofwork: "",
      weightage: 100,
      roletype: "Primary",
      rolelevel: "",
      appraiser: "",
      appraisal: "Yes",
    },
  ]);

  const jobDescriptions = [
    "Job Description – Financial & Administration Manager",
    "Job Description – Manager – Marketing and Business development",
    "Job Description – Manager (Human Resources)",
    "Job Description – Manager IT",
  ];

  async function encrypt(text) {
    const enc = new TextEncoder();
    const keyData = enc.encode("BDOsecur@1234567BDOsecur@1234567");
    const iv = enc.encode("BDOsecur@1234567");
    const cryptoKey = await window.crypto.subtle.importKey(
      "raw",
      keyData,
      { name: "AES-CBC", length: 256 },
      false,
      ["encrypt"]
    );
    const encrypted = await window.crypto.subtle.encrypt(
      { name: "AES-CBC", iv },
      cryptoKey,
      enc.encode(text)
    );
    return Array.from(new Uint8Array(encrypted))
      .map(b => b.toString(16).padStart(2, "0"))
      .join("");
  }

  // Function to handle modal close
  const onCancel = () => {
    if (isHistory) {
      setIsHistory(false);
    }
    form.setFieldValue("file", []);
    setOtherFileList([]);
    setSelectedOption(null);
    setIsModalVisible(false);

    form.setFieldsValue({ jobDescription: undefined });
    setSelectedOption(null);
  };
  const handleGradeChange = (value) => {
    setData((prevData) =>
      prevData.map((row) => ({
        ...row,
        jobdescriptionFileName: "",
        jobdescriptionFileUrl: "",
      }))
    );
    setAddedJobDescriptions({});
    setFormValues((prev) => ({
      ...prev,
      grade: value,
    }));
    setChargeout();
    setTargetChargeability();
  };

  // Function to handle form submit
  // ...existing code...
  const handleFinish = async () => {
    const selectedJobDescriptionId =
      selectedOption || form.getFieldValue("jobDescription");
    const fileList = form.getFieldValue("file");
    if (!selectedJobDescriptionId && (!fileList || fileList.length === 0)) {
      message.error("Please select or upload a job description");
      return;
    }

    setIsModalVisible(false);
    setShowConfirmModal(true);

    let fileName = "";
    let jobDescriptionId = "";
    let fileUrl = "";
    let fromDate = "";
    let toDate = "";
    let otherFile = "No";
    // If selected from radio
    if (selectedJobDescriptionId) {
      const selectedDescObj = filteredJobDescriptions.find(
        (desc) => desc.jobDescriptionId === selectedJobDescriptionId
      );
      fileName = selectedDescObj?.fileName || "";
      jobDescriptionId =
        selectedDescObj?.jobDescriptionId || selectedJobDescriptionId;
      fileUrl = selectedDescObj?.fileUrl || "";
      fromDate = selectedDescObj?.fromDate;
      toDate = selectedDescObj?.toDate;
      otherFile = "No";
    }

    // If uploaded file
    if (fileList && fileList.length > 0) {
      const file = fileList[0];
      fileName = file.name;
      jobDescriptionId = file?.jobDescriptionId; // Or use a real ID if available
      fileUrl = file.fileUrl; // Set if you have a URL after upload
      fromDate = "";
      toDate = "";
      otherFile = "Yes";
    }

    if (currentRoleRecord) {
      setAddedJobDescriptions((prev) => ({
        ...prev,
        [currentRoleRecord.key]: {
          fileName,
          jobDescriptionId,
          fileUrl,
          fromDate,
          toDate,
          otherFile,
        },
      }));

      setData((prevData) =>
        prevData.map((row) =>
          row.key === currentRoleRecord.key
            ? {
              ...row,
              jobdescriptionFileName: fileName,
              jobdescriptionFileUrl: fileUrl,
              jobDescriptionId: jobDescriptionId,
              fromDate: fromDate,
              toDate: toDate,
              otherFile: otherFile,
            }
            : row
        )
      );
    }
    form.setFieldValue("file", []);
    setOtherFileList([]);
    setTimeout(() => {
      setShowConfirmModal(false);
    }, 1800);
  };
  // ...existing code...

  const [pdfUrl, setPdfUrl] = useState(null);
  const [isPdfModalVisible, setIsPdfModalVisible] = useState(false);

  const handleViewJobDescription = async (row) => {
    const desc = addedJobDescriptions[row.key];

    if (!desc) {
      message.warning("Job description not found.");
      return;
    }

    setViewLoading(true);
    try {
      const jobdescriptionid = desc.jobDescriptionId;
      const filename = desc.fileName;
      const token = window.localStorage.getItem("token") || "";

      const response = await axios.get(
        `https://ozwcklfzkf.execute-api.ap-south-1.amazonaws.com/Prod/appraisal/getdocument`,
        {
          params: { jobdescriptionid, filename },
          headers: { Insytsjwt: token },
        }
      );

      if (response.data.status === "SUCCESS" && response.data.url) {
        setPdfUrl(response.data.url);
        setIsPdfModalVisible(true);
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
        error.message ||
        "Failed to fetch document."
      );
    } finally {
      setViewLoading(false);
    }
  };

  useEffect(() => {
    if (
      formValues?.serviceline?.length > 0 ||
      formValues?.subserviceline?.length > 0 ||
      formValues?.managingoffice ||
      formValues?.officesupervisorId
    ) {
      setData((prevData) => {
        const prevAppraiser = prevData[0]?.appraiser || "";
        const prevAppraiserName = prevData[0]?.appraiserName || "";

        const selectedSupervisor = supervisorList?.find(
          (user) => user.employeeId === formValues.officesupervisorId
        );

        const appraiserId = formValues.userid || prevAppraiser;

        const appraiserName = selectedSupervisor?.name || prevAppraiserName;
        const primaryRow = prevData.find(
          (row) => row.roletype === "Primary"
        ) || { key: 1 };
        const updatedPrimary = {
          ...primaryRow,
          orgLevel: formValues.managingoffice || "",
          areaofwork:
            formValues.serviceline?.length > 1
              ? formValues.serviceline.join(", ")
              : formValues.serviceline?.[0] || "",
          subareaofwork:
            formValues.subserviceline?.length > 1
              ? formValues.subserviceline.join(", ")
              : formValues.subserviceline?.[0] || "",
          weightage:
            prevData[0]?.weightage !== 100 ? prevData[0]?.weightage : 100,
          roletype: "Primary",
          rolelevel: "",
          appraiser: supervisorList?.find(
            (user) => user.employeeId === form.getFieldValue("officesupervisor")
          )?.userid,
          appraiserName: appraiserName,
          appraisal: "Yes",
          jobdescriptionFileName: filteredJobDescriptions?.[0]?.fileName || "",
          jobdescriptionFileUrl: filteredJobDescriptions?.[0]?.fileUrl || "",
        };
        // Keep all additional rows
        const additionalRows = prevData.filter(
          (row) => row.roletype !== "Primary"
        );
        return [updatedPrimary, ...additionalRows];
      });
      initializedRef.current = true;
    }
  }, [
    formValues?.managingoffice,
    formValues?.serviceline,
    formValues?.subserviceline,
    formValues?.officesupervisorId,
    supervisorList,
    form.getFieldValue("officesupervisor"),
  ]);
  const locationId = chain(roleList)
    .filter((role) => selectedRoleId.includes(role.roleId))
    .flatMap((role) => role.locationId)
    .uniq()
    .value();

  const locationBasedOnRole = locationList?.filter(
    (val) =>
      locationId.includes(val?.location_id) && val?.login_from_anywhere !== 1
  );

  const [employeeStatusId, setEmployeeStatusId] = useState("1");
  const filterDepartment = roleList?.find((item) =>
    form.getFieldValue("role_id")?.includes(item?.roleId)
  )?.department;

  const [emailsList, setEmailList] = useState([]);

  const getEmailList = async () => {
    const response = await CALL_API(`add-users/email-list`, "get");
    if (response.code === STATUS_CODE.SUCCESS) setEmailList(response.response);
  };

  const getSerialNo = async () => {
    const response = await CALL_API(`add-users/serialno`, "get");
    if (response.code === STATUS_CODE.SUCCESS) setSerialNo(response.serialno);
  };

  useEffect(() => {
    setSelectAllRoleChecked(selectedRoleId.length === roleList.length);
  }, [selectedRoleId, selectAllRoleChecked, roleList]);

  useEffect(() => {
    setProfileUploaded(false);
    getEmailList();
    // getSerialNo();
  }, []);

  useEffect(() => {
    if (!isEmpty(selectedDetails)) {
      const educationdetails = selectedDetails?.educationdetails.map(
        (detail) => ({
          ...detail,
          todate: detail.todate ? moment(detail.todate) : null,
          fromdate: detail.fromdate ? moment(detail.fromdate) : null,
        })
      );

      const practicaltrainings = selectedDetails?.practicaltrainings.map(
        (detail) => ({
          ...detail,
          todate: detail.todate ? moment(detail.todate) : null,
          fromdate: detail.fromdate ? moment(detail.fromdate) : null,
        })
      );

      const professionalcertifications =
        selectedDetails?.professionalcertifications.map((detail) => ({
          ...detail,
          todate: detail.todate ? moment(detail.todate) : null,
          fromdate: detail.fromdate ? moment(detail.fromdate) : null,
        }));

      const workexperience = selectedDetails?.workexperience.map((detail) => ({
        ...detail,
        todate: detail.todate ? moment(detail.todate) : null,
        fromdate: detail.fromdate ? moment(detail.fromdate) : null,
      }));

      let values = {
        user_id: selectedDetails?.userid,
        gender: selectedDetails?.gender,
        nssf: selectedDetails?.nssf,
        national_id: selectedDetails?.national_id,
        phoneno: selectedDetails?.phoneno,
        physicaladdress: selectedDetails?.physicaladdress,
        maritalstatus: selectedDetails?.maritalstatus,
        country: selectedDetails?.country,
        nationality: selectedDetails?.nationality,
        dateofbirth: selectedDetails?.dateofbirth
          ? moment(selectedDetails?.dateofbirth, "YYYY-MM-DD")
          : null,
        emergencycontactname: selectedDetails?.emergencycontactname,
        emergencycontactnumber: selectedDetails?.emergencycontactnumber,
        firstname: selectedDetails?.firstname,
        lastname: selectedDetails?.lastname,
        salutation: selectedDetails?.salutation,
        greetings: selectedDetails?.greetings,
        dependent: selectedDetails?.dependent,
        educationdetails: educationdetails,
        workexperience: workexperience,
        professionalcertifications: professionalcertifications,
        practicaltrainings: practicaltrainings,
        othernames: selectedDetails?.othernames,
        postaladdress: selectedDetails?.postaladdress,
        workpermitno: selectedDetails?.workpermitno,
        workpermitexpirydate: selectedDetails?.workpermitexpirydate
          ? moment(selectedDetails?.workpermitexpirydate)
          : null,
        nextofkinrelationship: selectedDetails?.nextofkinrelationship,
        nextofkinpostaladdress: selectedDetails?.nextofkinpostaladdress,
        accountno: selectedDetails?.accountno,
        accountname: selectedDetails?.accountname,
        bankname: selectedDetails?.bankname,
        bankbranch: selectedDetails?.bankbranch,
        bankcountry: selectedDetails?.bankcountry,
        bankcode: selectedDetails?.bankcode,
        bankbranchcode: selectedDetails?.bankbranchcode,
        bankswiftcode: selectedDetails?.bankswiftcode,
        krapin: selectedDetails?.krapin,
        nhif: selectedDetails?.nhif,
        // onboardingdate: signdate
        personalemailid: selectedDetails?.personalemailid,
        previousstatusid: selectedDetails?.statusid
      };
      setFormValues(values);
      form.setFieldsValue(values);
    }
  }, [selectedDetails]);

  const emailList = EmployeeList?.map((user) => user.userid);
  // const filteredUserName = userList
  //   ?.filter((item) => item.roleid.includes("4"))
  //   ?.map((item) => item.fullname);

  const [step, setStep] = useState(defaultStep);
  const [reviewBasicData, setReviewBasicData] = useState({});
  const [reviewEducationData, setReviewEducationData] = useState({});
  const [reviewWorkData, setReviewWorkData] = useState({});
  const [managingOfficeData, setManagingOfficeData] = useState([]);
  const [organisationLevelData, setOrganisationLevelData] = useState([]);
  const [competencyQCData, setCompetencyQCfetchData] = useState([]);
  const [servicelineData, setServicelinefetchData] = useState([]);
  const [subservicelineData, setsubservicelineData] = useState([]);
  const [competencyroleData, setcompetencyroleData] = useState([]);
  const [departmentLevelData, setDepartmentLevelData] = useState([]);
  const [currentRoleRecord, setCurrentRoleRecord] = useState(null);
  const [filteredJobDescriptions, setFilteredJobDescriptions] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [addedJobDescriptions, setAddedJobDescriptions] = useState({}); // { [rowKey]: { fileName, jobDescriptionId } }
  const [viewLoading, setViewLoading] = useState(false);
  const [addLoadingRow, setAddLoadingRow] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyDatas, setHistoryData] = useState([]);
  const [otherFileList, setOtherFileList] = useState([]);
  const userInfo = useSelector((store) => get(store, "common.userInfo"));
  const GradeandGradeCodes = useSelector((state) => getChargeoutRatesList(state));

  const handleUpload = ({ file, onSuccess }) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64Data = reader.result.split(",")[1];
      onSuccess();
    };
    reader.onerror = (error) => {
      console.error("File read error:", error);
    };
  };
  const normFile = (e) => {
    if (Array.isArray(e)) return e;
    return e?.fileList;
  };

  const fetchData = async () => {
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level1`,
      "get"
    );
    if (!isEmpty(response)) {
      const result = flatMap(response.data, (item) =>
        item.value.map((value) => ({ name: item.name, value }))
      );
      setManagingOfficeData(result);
    }
  };

  const organisationLevelfetchData = async () => {
    const filtervalue = managingOfficeData.filter((item) =>
      form.getFieldValue("managingoffice").includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level2&parentLevel=[${mapdata}]`,
      "get"
    );
    if (!isEmpty(response)) {
      const result = flatMap(response.data, (item) =>
        item.value.map((value) => ({
          name: item.name,
          value,
          parentLevel: item.parentLevel,
        }))
      );
      setOrganisationLevelData(result);
      if (isEmpty(result)) {
        form.setFieldValue("organisationlevel", []);
        form.setFieldValue("competencyQC", []);
        form.setFieldValue("serviceline", []);
        form.setFieldValue("subserviceline", []);
        form.setFieldValue("leveldepartmentname", []);
      } else {
        // organisationlevel
        const organisationlevelList = filter(result, (item) =>
          form.getFieldValue("managingoffice").includes(item.parentLevel)
        );
        const organisationlevel = filter(
          form.getFieldValue("organisationlevel"),
          (value) => find(organisationlevelList, { value: value })
        );
        form.setFieldValue("organisationlevel", organisationlevel);
        // competencyQC

        const competencyQClevelList = filter(competencyQCData, (item) =>
          form.getFieldValue("organisationlevel").includes(item.parentLevel)
        );
        setCompetencyQCfetchData(competencyQClevelList);
        const competencyQClevel = filter(
          form.getFieldValue("competencyQC"),
          (value) => find(competencyQClevelList, { value: value })
        );
        form.setFieldValue("competencyQC", competencyQClevel);
        // serviceline
        const servicelinelevelList = filter(servicelineData, (item) =>
          form.getFieldValue("competencyQC").includes(item.parentLevel)
        );
        setServicelinefetchData(servicelinelevelList);
        const serviceline = filter(form.getFieldValue("serviceline"), (value) =>
          find(servicelinelevelList, { value: value })
        );
        form.setFieldValue("serviceline", serviceline);
        // subserviceline
        const subservicelinelevelList = filter(subservicelineData, (item) =>
          form.getFieldValue("serviceline").includes(item.parentLevel)
        );
        setsubservicelineData(subservicelinelevelList);
        const subserviceline = filter(
          form.getFieldValue("subserviceline"),
          (value) => find(subservicelinelevelList, { value: value })
        );
        form.setFieldValue("subserviceline", subserviceline);
        //  // competencyrole
        //  const competencyrolelevelList = filter(subservicelineData, item => form.getFieldValue('subserviceline').includes(item.parentLevel))
        //  setcompetencyroleData(competencyrolelevelList)
        //  const competencyrole = filter(form.getFieldValue('competencyrole'), value => find(competencyrolelevelList, { 'value': value }));
        //  form.setFieldValue('competencyrole', competencyrole);
      }
    }
  };

  const competencyQCfetchData = async () => {
    const filtervalue = managingOfficeData.filter((item) =>
      form.getFieldValue("managingoffice").includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level2&parentLevel=[${mapdata}]`,
      "get"
    );
    if (!isEmpty(response)) {
      const result = flatMap(response.data, (item) =>
        item.value.map((value) => ({
          name: item.name,
          value,
          parentLevel: item.parentLevel,
        }))
      );
      setCompetencyQCfetchData(result);
      if (isEmpty(result)) {
        form.setFieldValue("competencyQC", []);
        form.setFieldValue("serviceline", []);
        form.setFieldValue("subserviceline", []);
        form.setFieldValue("competencyrole", []);
        form.setFieldValue("leveldepartmentname", []);
      } else {
        // competencyQC

        const competencyQClevelList = filter(result, (item) =>
          form.getFieldValue("organisationlevel")?.includes(item.parentLevel)
        );
        const competencyQClevel = filter(
          form.getFieldValue("competencyQC"),
          (value) => find(competencyQClevelList, { value: value })
        );
        form.setFieldValue("competencyQC", competencyQClevel);
        // serviceline
        const servicelinelevelList = filter(servicelineData, (item) =>
          form.getFieldValue("competencyQC")?.includes(item.parentLevel)
        );
        setServicelinefetchData(servicelinelevelList);
        const serviceline = filter(form.getFieldValue("serviceline"), (value) =>
          find(servicelinelevelList, { value: value })
        );
        form.setFieldValue("serviceline", serviceline);
        // subserviceline
        const subservicelinelevelList = filter(subservicelineData, (item) =>
          form.getFieldValue("serviceline")?.includes(item.parentLevel)
        );
        setsubservicelineData(subservicelinelevelList);
        const subserviceline = filter(
          form.getFieldValue("subserviceline"),
          (value) => find(subservicelinelevelList, { value: value })
        );
        form.setFieldValue("subserviceline", subserviceline);
        // competencyrole
        // const competencyrolelevelList = filter(subservicelineData, item => form.getFieldValue('subserviceline').includes(item.parentLevel))
        // setcompetencyroleData(competencyrolelevelList)
        // const competencyrole = filter(form.getFieldValue('competencyrole'), value => find(competencyrolelevelList, { 'value': value }));
        // form.setFieldValue('competencyrole', competencyrole);
      }
    }
  };

  const servicelinefetchData = async () => {
    const filtervalue = competencyQCData.filter((item) =>
      form.getFieldValue("competencyQC")?.includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level3&parentLevel=[${mapdata}]`,
      "get"
    );
    if (!isEmpty(response)) {
      const result = flatMap(response.data, (item) =>
        item.value.map((value) => ({
          name: item.name,
          value,
          parentLevel: item.parentLevel,
        }))
      );
      setServicelinefetchData(result);
      if (isEmpty(result)) {
        form.setFieldValue("serviceline", []);
        form.setFieldValue("subserviceline", []);
        form.setFieldValue("leveldepartmentname", []);
      } else {
        // serviceline
        const servicelinelevelList = filter(result, (item) =>
          form.getFieldValue("competencyQC").includes(item.parentLevel)
        );
        const serviceline = filter(form.getFieldValue("serviceline"), (value) =>
          find(servicelinelevelList, { value: value })
        );
        form.setFieldValue("serviceline", serviceline);
        // subserviceline
        const subservicelinelevelList = filter(subservicelineData, (item) =>
          form.getFieldValue("serviceline").includes(item.parentLevel)
        );
        setsubservicelineData(subservicelinelevelList);
        const subserviceline = filter(
          form.getFieldValue("subserviceline"),
          (value) => find(subservicelinelevelList, { value: value })
        );
        form.setFieldValue("subserviceline", subserviceline);
        // // competencyrole
        // const competencyrolelevelList = filter(subservicelineData, item => form.getFieldValue('subserviceline').includes(item.parentLevel))
        // setcompetencyroleData(competencyrolelevelList)
        // const competencyrole = filter(form.getFieldValue('competencyrole'), value => find(competencyrolelevelList, { 'value': value }));
        // form.setFieldValue('competencyrole', competencyrole);
      }
    }
  };

  const subservicelinefetchData = async () => {
    const filtervalue = servicelineData?.filter((item) =>
      form.getFieldValue("serviceline")?.includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level4&parentLevel=[${mapdata}]`,
      "get"
    );

    if (!isEmpty(response)) {
      const result = response?.data?.flatMap((item) =>
        item.value.map((value) => ({
          name: item.name,
          value,
          parentLevel: item.parentLevel,
        }))
      );
      setsubservicelineData(result);
      if (isEmpty(result)) {
        form.setFieldValue("leveldepartmentname", []);
      } else {
        // subserviceline
        const subservicelinelevelList = filter(result, (item) =>
          form.getFieldValue("serviceline").includes(item.parentLevel)
        );
        // // competencyrole
        // const competencyrolelevelList = filter(subservicelineData, item => form.getFieldValue('subserviceline').includes(item.parentLevel))
        // setcompetencyroleData(competencyrolelevelList)
        // const competencyrole = filter(form.getFieldValue('competencyrole'), value => find(competencyrolelevelList, { 'value': value }));
        // form.setFieldValue('competencyrole', competencyrole);
      }
    }
  };
  const departmentfetchData = async () => {
    const filtervalue = subservicelineData?.filter((item) =>
      form.getFieldValue("subserviceline")?.includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level5&parentLevel=[${mapdata}]`,
      "get"
    );
    if (!isEmpty(response)) {
      const result = flatMap(response.data, (item) =>
        item.value.map((value) => ({
          name: item.name,
          value,
          parentLevel: item.parentLevel,
        }))
      );
      setDepartmentLevelData(result);
      if (isEmpty(result)) {
        form.setFieldValue("competencyrole", []);
      } else {
        // subserviceline
        const subservicelinelevelList = filter(result, (item) =>
          form.getFieldValue("serviceline").includes(item.parentLevel)
        );
        // // competencyrole
        // const competencyrolelevelList = filter(subservicelineData, item => form.getFieldValue('subserviceline').includes(item.parentLevel))
        // setcompetencyroleData(competencyrolelevelList)
        // const competencyrole = filter(form.getFieldValue('competencyrole'), value => find(competencyrolelevelList, { 'value': value }));
        // form.setFieldValue('competencyrole', competencyrole);
      }
    }
  };
  const competencyrolefetchData = async () => {
    const filtervalue = subservicelineData.filter((item) =>
      form.getFieldValue("subserviceline")?.includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level6&parentLevel=[${mapdata}]`,
      "get"
    );
    // if (!isEmpty(response)) {
    //   const result = flatMap(response.data, item => item.value.map(value => ({ name: item.name, value, parentLevel: item.parentLevel })));
    //   setcompetencyroleData(result)
    //   if (isEmpty(result)) {
    //     form.setFieldValue('competencyrole', []);
    //   } else {
    //     // competencyrole
    //     const competencyrolelevelList = filter(result, item => form.getFieldValue('subserviceline').includes(item.parentLevel))
    //     const competencyrole = filter(form.getFieldValue('competencyrole'), value => find(competencyrolelevelList, { 'value': value }));
    //     form.setFieldValue('competencyrole', competencyrole);
    //   }
    // }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchMasterData = async (fetch_master_data) => {
    const { code, userList, roleList } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      {
        fetch_master_data,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      saveRoleList(roleList);
      updateUserList(userList);
    }
  };
  const validateEmployeeId = (rule, value) => {
    if (value && emailsList.includes(value) && isEmpty(selectedDetails)) {
      return Promise.reject("User ID already exist");
    }
    return Promise.resolve();
  };

  // Note: params needed
  const handlesubmit = async (values) => {
    try {
      //   toggleLoader(true);
      setUniqueId(generateUniqueId());
      const officeSupervisorId = form.getFieldValue("officesupervisor");
      const officeSupervisorObj = supervisorList?.find(
        (sup) => sup.employeeId === officeSupervisorId
      );

      const officeSupervisorUserId = officeSupervisorObj?.userid;

      const dataWithJobDesc = data.map((row) => {
        const added = addedJobDescriptions[row.key];
        // If Primary, set appraiser to officeSupervisorId
        const appraiserValue =
          row.roletype === "Primary" ? officeSupervisorUserId : row.appraiser;
        return {
          ...row,
          appraiser: appraiserValue,
          jobdescriptionFileName:
            added?.fileName || row.jobdescriptionFileName || "",
          jobdescriptionFileUrl:
            added?.fileUrl || row.jobdescriptionFileUrl || "",
          jobDescriptionId:
            added?.jobDescriptionId || row.jobDescriptionId || "",
        };
      });

      const submitedValues = form.getFieldValue();
      const {
        firstname,
        lastname,
        salutation,
        othernames,
        dateofbirth,
        gender,
        dependent,
        maritalstatus,
        phoneno,
        user_id,
        postaladdress,
        physicaladdress,
        password,
        country,
        greetings,
        national_id,
        nationality,
        workpermitno,
        workpermitexpirydate,
        emergencycontactname,
        emergencycontactnumber,
        nextofkinrelationship,
        nextofkinpostaladdress,
        educationdetails,
        practicaltrainings,
        professionalcertifications,
        workexperience,
        accountname,
        accountno,
        bankname,
        bankbranch,
        bankcountry,
        bankcode,
        bankbranchcode,
        bankswiftcode,
        nssf,
        krapin,
        nhif,
        helpmonthlybilling,
        managingoffice,
        competencyQC,
        serviceline,
        subserviceline,
        leveldepartmentname,
        competencyrole,
        levellocationid,
        supervisor,
        companyname,
        industry,
        secondaryIndustry,
        sector,
        expertise,
        industryrole,
        regionalsupervisor,
        regionalcompetencyrole,
        officesupervisor,
        engagementsupervisor,
        designation,
        grade,
        targetchargeability,
        chargeoutrate,
        lastpromotionlevel,
        lastpromotion,
        jobtitle,
        professionalsince,
        hireddate,
        employeesponser,
        employee_status,
        roleId,
        baselocationid,
        shiftstarttime,
        shiftendtime,
        personalemailid,
        previousstatusid,
      } = formValues;
      let userId = form.getFieldValue("user_id");
      let splitUserId = userId.split("@");
      let userIdWithoutDomain = splitUserId[0];
      let updatedUserId = userIdWithoutDomain + storeId;
      const dobDate = new Date(dateofbirth);
      const currentDate = new Date();
      const agecalculte = currentDate.getFullYear() - dobDate.getFullYear();
      // const bandNameList = bandList?.filter((item) => item?.bandId === bandid);

      const workexperienceDetails = workexperience?.map((item) => {
        const { fromdate, todate, ...rest } = item;
        const formattedFromDate = fromdate
          ? moment(fromdate).format("YYYY-MM-DD")
          : null;
        const formattedToDate = todate
          ? moment(todate).format("YYYY-MM-DD")
          : null;
        return {
          ...rest,
          fromdate: formattedFromDate,
          todate: formattedToDate,
        };
      });

      const transformedEducationDetails = educationdetails?.map((item) => {
        const { attachment, fromdate, todate, ...rest } = item;
        const formattedFromDate = fromdate
          ? moment(fromdate).format("YYYY-MM-DD")
          : null;
        const formattedToDate = todate
          ? moment(todate).format("YYYY-MM-DD")
          : null;
        const updatedAttachment = attachment?.map((att) => ({
          name: att?.name,
          uniqueId: att?.response?.uniqueId
            ? att?.response?.uniqueId
            : att?.uniqueId,
        }));
        return {
          ...rest,
          fromdate: formattedFromDate,
          todate: formattedToDate,
          attachment: updatedAttachment,
        };
      });

      const practicaltrainingsDetails = practicaltrainings?.map((item) => {
        const { fromdate, todate, ...rest } = item;
        const formattedFromDate = fromdate
          ? moment(fromdate).format("YYYY-MM-DD")
          : null;
        const formattedToDate = todate
          ? moment(todate).format("YYYY-MM-DD")
          : null;
        return {
          ...rest,
          fromdate: formattedFromDate,
          todate: formattedToDate,
        };
      });
      const professionalcertificationsDetails = professionalcertifications?.map(
        (item) => {
          const { attachment, fromdate, todate, ...rest } = item;
          const formattedFromDate = fromdate
            ? moment(fromdate).format("YYYY-MM-DD")
            : null;
          const formattedToDate = todate
            ? moment(todate).format("YYYY-MM-DD")
            : null;
          const updatedAttachment = attachment?.map((att) => ({
            name: att?.name,
            uniqueId: att?.response?.uniqueId
              ? att?.response?.uniqueId
              : att?.uniqueId,
          }));
          return {
            ...rest,
            fromdate: formattedFromDate,
            todate: formattedToDate,
            attachment: updatedAttachment,
          };
        }
      );
      const selectedRole = roleList.find(r => r.roleId === roleId);
      const roleName = selectedRole?.roleName || "";
      const subClusterChecked = form.getFieldValue("subCluster") || false;
      const subClusterCountries = form.getFieldValue("subClusterList") || [];
      const encrypted = await encrypt(submitedValues?.password);

      const normalizeCountry = (value) => {
        if (!value) return [];
        if (Array.isArray(value)) {
          return Array.isArray(value[0]) ? value[0] : value;
        }
        return [value];
      };

      const payload = {
        full_name: `${firstname} ${lastname}`,
        allowme: encrypted,
        user_id: user_id,
        start_date: hireddate
          ? moment(hireddate._d).format("YYYY-MM-DD")
          : "",
        gender: gender,
        status_id: employeeStatusId,
        profile_url: profileUploaded
          ? `https://insyts-dubai-profiles.s3.me-south-1.amazonaws.com/${ClientId}/${updatedUserId}/${storeId}.jpg`
          : null,
        nssf: nssf,
        national_id: national_id,
        phoneno: phoneno,
        physicaladdress: physicaladdress,
        professionalsince: professionalsince
          ? moment(professionalsince._d).format("YYYY-MM-DD")
          : "",
        hireddate: hireddate ? moment(hireddate._d).format("YYYY-MM-DD") : "",
        statusname: "Active" || employee_status,
        employeesponser: employeesponser,
        age: agecalculte,
        maritalstatus: maritalstatus,
        country: country,
        nationality: nationality,
        companyname: companyname,
        jobtitle: jobtitle,
        dateofbirth: dateofbirth,
        emergencycontactname: emergencycontactname,
        emergencycontactnumber: emergencycontactnumber,
        employeeid: `EMP000${serialNo}`,
        firstname: firstname,
        lastname: lastname,
        salutation: salutation,
        competencyQC: competencyQC,
        serviceline: serviceline,
        subserviceline: subserviceline,
        competencyrole: competencyrole,
        industry: industry,
        sector: sector,
        industryrole: industryrole,
        expertise: expertise,
        designation: designation,
        grade: grade,
        targetchargeability: targetchargeability,
        chargeoutrate: chargeoutrate,
        greetings: greetings,
        lastpromotionlevel: lastpromotionlevel
          ? moment(lastpromotionlevel._d).format("YYYY-MM-DD")
          : "",
        dependent: dependent,
        educationdetails: transformedEducationDetails,
        workexperience: workexperienceDetails,
        professionalcertifications: professionalcertificationsDetails,
        practicaltrainings: practicaltrainingsDetails,
        managingoffice: normalizeCountry(managingoffice),
        supervisor: get(
          find(supervisorList, { employeeId: supervisor }),
          "name",
          null
        ),
        lastpromotion: lastpromotion,
        levellocationid: levellocationid || filteredLocationsData[0]?.location_id,
        baselocationid: levellocationid || filteredLocationsData[0]?.location_id,
        secondaryindustry: secondaryIndustry,
        leveldepartmentname: leveldepartmentname,
        regionalsupervisor:
          regionalsupervisor !== "none"
            ? get(
              find(supervisorList, { employeeId: regionalsupervisor }),
              "name",
              null
            )
            : "none",
        officesupervisor:
          officesupervisor !== "none"
            ? get(
              find(supervisorList, { employeeId: officesupervisor }),
              "name",
              null
            )
            : "none",
        engagementsupervisor: get(
          find(supervisorList, { employeeId: engagementsupervisor }),
          "name",
          null
        ),
        OfficeSupervisorEmailId:
          officesupervisor !== "none"
            ? get(
              find(supervisorList, { employeeId: officesupervisor }),
              "userid",
              null
            )
            : "none",
        OfficeSupervisorId: officesupervisor,
        RegionalSupervisorId: regionalsupervisor,
        othernames: othernames,
        postaladdress: postaladdress,
        workpermitno: workpermitno,
        workpermitexpirydate: workpermitexpirydate
          ? moment(workpermitexpirydate._d).format("YYYY-MM-DD")
          : "",
        nextofkinrelationship: nextofkinrelationship,
        nextofkinpostaladdress: nextofkinpostaladdress,
        accountno: accountno,
        accountname: accountname,
        bankname: bankname,
        bankbranch: bankbranch,
        bankcountry: bankcountry,
        bankcode: bankcode,
        bankbranchcode: bankbranchcode,
        bankswiftcode: bankswiftcode,
        krapin: krapin,
        nhif: nhif,
        helpmonthlybilling: helpmonthlybilling,
        shiftstarttime: shiftstarttime
          ? moment(shiftstarttime).format("HH:mm")
          : "",
        shiftendtime: shiftendtime
          ? moment(shiftendtime).format("HH:mm")
          : "",
        regionalcompetencyrole: selectedDetails?.regionalcompetencyrole || "",
        onboardtype: true,
        appraisalInformation: dataWithJobDesc,
        personalemailid: personalemailid,
        previousstatusid: previousstatusid,
        role_id: [roleId],
        subcluster: subClusterChecked,
        role_name: [roleName],
        subclustercountries: subClusterChecked ? subClusterCountries : [],
        leaveAccurals: form.getFieldValue("leaveAccurals") || [],
      }
      const response = await CALL_API(
        `add-users/${ClientId}`,
        isEmpty(selectedDetails) ? "post" : "patch", payload
      );
      toggleLoader(false);
      setFileName("");
      closeModal();

      if (response.code === "SUCCESS") {
        form.resetFields();
        if (response?.message === "Please Upgrade Your Plan") {
          message.error(response?.message);
        } else {
          message.success(response?.message);
        }
      }
      getEmployeeList();
      setTimeout(() => {
        fetchMasterData(true); // Execute after a delay
      }, 2000);
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  function generateUniqueId() {
    const usedIds = [];
    let uniqueId = "";
    while (uniqueId.length !== 6) {
      const randomNumber = Math.floor(Math.random() * 900000) + 100000;
      if (!usedIds.includes(randomNumber.toString())) {
        usedIds.push(randomNumber.toString());
        uniqueId += randomNumber.toString();
      }
    }
    return uniqueId;
  }

  const Reset = () => {
    form.resetFields();
    setFileName("");
  };

  const { key, url } = queryKeys.getChargeoutRates;
  const { data: gradeDataRes } = useFetch(key, url);

  const gradeData = gradeDataRes?.response?.items;

  const gradeOptions = gradeData
    ? gradeData?.map((item) => ({
      label: item.jobgradecode,
      value: item.jobgradecode,
      rate: parseInt(item.DRC) || 0,
      targetchargeability: parseInt(item.targetchargeability, 10) || 0,
    }))
    : [];

  const gradeToDesignationMap = useMemo(() => {
    const map = {};
    gradeData?.forEach(item => {
      map[item.jobgradecode] = item.jobgrade; // Job Grade Title
    });
    return map;
  }, [gradeData]);

  const setChargeout = () => {
    const selectedGrade = form.getFieldValue("grade");
    const managingoffice = form.getFieldValue("managingoffice");
    const countryCode = countryNameToCode[managingoffice];
    if (selectedGrade && countryCode) {
      const selectedGradeData = gradeData?.find(
        (item) => item.jobgradecode === selectedGrade
      );
      const rate = parseFloat(selectedGradeData?.[countryCode]) || 0;
      form.setFieldsValue({ chargeoutrate: rate });
      setFormValues((prev) => ({
        ...prev,
        chargeoutrate: rate,
      }));
    }
  };

  const setTargetChargeability = () => {
    const selectedGrade = form.getFieldValue("grade");

    if (selectedGrade) {
      const target = gradeOptions.find(
        (item) => item.value === selectedGrade
      )?.targetchargeability;

      form.setFieldsValue({ targetchargeability: target });
      setFormValues((prev) => ({
        ...prev,
        targetchargeability: target,
      }));
    }
  };

  const onFinish = (step) => {
    const currentFormValues = form.getFieldValue();
    setFormValues({
      ...currentFormValues,
      appraisalData: data,
    });
    if (step === 5) {
      setReviewBasicData({
        salutation: formValues?.salutation,
        initial: formValues?.initial,
        firstname: formValues?.firstname,
        lastname: formValues?.lastname,
        employeeid: formValues?.employeeid,
        user_id: formValues?.user_id,
        date_of_birth: formValues?.date_of_birth
          ? moment(formValues?.date_of_birth?._d).format("YYYY-MMMM-DD")
          : "",
        password: formValues?.password
          ? "*".repeat(formValues.password.length - 2) +
          formValues.password.slice(-2)
          : "",
        gender: formValues?.gender,
        phone: formValues?.phone,
        marital_status: formValues?.marital_status,
        nationality: formValues?.nationality,
        nssf: formValues?.nssf,
        national_id: formValues?.national_id,
        address: formValues?.address,
        start_date: formValues?.start_date
          ? moment(formValues?.start_date?._d).format("YYYY-MMMM-DD")
          : "-",
        EmergencyContactName: formValues?.emergencycontactname,
        EmergencyContactNumber: formValues?.emergencycontactnumber,
        employementtype: formValues?.employementtype,
        competencyQC: formValues?.competencyQC,
        serviceline: formValues?.serviceline,
        subserviceline: formValues?.subserviceline,
        competencyrole: formValues?.competencyrole,
        organisationlevel: formValues?.organisationlevel,
        managingoffice: formValues?.managingoffice,
        supervisor: formValues?.supervisor,
        greetings: formValues?.greetings,
        dependent: formValues?.dependent,
      });

      setReviewEducationData({
        institute_Name: formValues?.institute_Name,
        degree: formValues?.degree,
        specialization: formValues?.specialization,
        professionalcertification: formValues?.professionalcertification,
        year_of_completion: formValues?.year_of_completion
          ? moment(formValues?.year_of_completion?._d).format("YYYY-MMMM-DD")
          : "-",
      });

      const missingPrimaryJobDescriptions = data?.filter((row) => {
        const added = addedJobDescriptions?.[row.key];
        const hasFile = !!added?.jobDescriptionId || !!added?.file;
        return !hasFile;
      });

      if (missingPrimaryJobDescriptions?.length > 0) {
        message.error(
          "Please add a Job Description for all  roles before proceeding."
        );
        return; // ✅ Block going forward
      }
    }
    setStep(step);
  };

  const uploadFile = async (value) => {
    const { file } = value;
    try {
      if (!isEmpty(file)) {
        const { user_id } = formValues;
        await CALL_API(`upload-userdocuments/${ClientId}`, "post", {
          userId: user_id?.toLowerCase(),
          name: file.name,
          type: file.type,
          uniqueId: file.response.uniqueId,
          content: file.response.base64Data,
        });
      }
    } catch (error) {
      console.error("[handlesubmit] error --->", error);
    }
  };

  const handleFileRemove = async (file) => {
    const userId = form.getFieldValue("user_id");
    let splitUserId = userId.split("@");
    let userIdWithoutDomain = splitUserId[0];
    let updatedUserId = userIdWithoutDomain;
    let fileKey = `${updatedUserId}_${file?.response?.uniqueId}_${file?.name
      .split(" ")
      .join("_")}`;
    try {
      await CALL_API(
        `delete-userdocuments?clientid=${ClientId}&filekey=${fileKey}`,
        "delete"
      );
    } catch (error) {
      console.error("[handleFileRemove] error -->", error);
    }
  };

  useEffect(() => {
    setReviewWorkData({
      company_Name: formValues?.company_Name,
      industry: formValues?.industry,
      secondaryIndustry: formValues?.secondaryIndustry,
      sector: formValues?.sector,
      industryrole: formValues?.industryrole,
      expertise: formValues?.expertise,
      designation: formValues?.designation,
      grade: formValues?.grade,
      targetchargeability: formValues?.targetchargeability,
      chargeoutrate: formValues?.chargeoutrate,
      job_Title: formValues?.job_Title,
      employee_sponser: formValues?.employee_sponser,
      description: formValues?.description,
      relevent: formValues?.relevent,
      professional_since: formValues?.professional_since
        ? moment(formValues?.professional_since?._d).format("YYYY")
        : "",
      hired_date: formValues?.hired_date
        ? moment(formValues?.hired_date?._d).format("YYYY-MMMM-DD")
        : "",
      employee_status: formValues?.employee_status,
      lastpromotionlevel: moment(formValues?.lastpromotionlevel?._d).format(
        "YYYY-MMMM-DD"
      ),
      lastpromotion: formValues?.lastpromotion,
    });
  }, [step]);

  //Note: need to future

  // const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  // useEffect(() => {
  //   if (form.getFieldValue("user_id")) {
  //     acceptedFiles.map((file) => {
  //       const reader = new FileReader();
  //       reader.onload = async function (e) {
  //         if (
  //           includes(
  //             [
  //               "image/jpeg",
  //               "image/jpg",
  //               "image/jpeg",
  //               "image/png",
  //               "image/tif",
  //               "image/tiff",
  //               "png",
  //               "jpg",
  //               "tif",
  //             ],
  //             get(file, "type", "")
  //           )
  //         ) {
  //           setFileName(acceptedFiles[0].path);
  //           setProfileUploaded(true);
  //           setUniqueId(generateUniqueId());
  //           let userId = form.getFieldValue("user_id");
  //           let splitUserId = userId.split("@");
  //           let userIdWithoutDomain = splitUserId[0];
  //           let updatedUserId = userIdWithoutDomain + uniqueId;
  //           const { code } = await CALL_API(
  //             `profile-upload/${ClientId}`,
  //             "post",
  //             {
  //               userid: updatedUserId,
  //               filetype: get(file, "type", ""),
  //               content: e.target.result,
  //               filename: uniqueId,
  //               emailid: "",
  //             }
  //           );
  //           if (code === STATUS_CODE.SUCCESS) {
  //             setStoreId(uniqueId);
  //           }
  //         } else {
  //           setProfileUploaded(false);
  //           message.error("Please upload valid image file.");
  //         }
  //       };
  //       reader.readAsDataURL(file);
  //       return file;
  //     });
  //   }
  // }, [acceptedFiles]);

  const fetchJobDescriptions = async () => {
    try {
      const selectedGrade = form.getFieldValue("grade");
      if (!selectedGrade) {
        setFilteredJobDescriptions([]);
        return;
      }
      const response = await CALL_API("appraisal/jobdescription", "get");
      const apiData = response?.data || response?.response?.data || [];
      if (Array.isArray(apiData)) {
        const today = dayjs().startOf("day");
        const filtered = apiData
          .filter(
            (item) =>
              item.jobGradeCode === selectedGrade &&
              item?.additionalFile !== "Yes" &&
              (item?.fromDate
                ? dayjs().isSameOrAfter(
                  dayjs(item.fromDate, "DD-MM-YYYY").startOf("day")
                )
                : true) &&
              (item?.toDate
                ? dayjs().isSameOrBefore(
                  dayjs(item.toDate, "DD-MM-YYYY").endOf("day")
                )
                : true)
          )
          ?.reverse();

        setFilteredJobDescriptions(
          filtered.map((item) => ({
            fileName: item.fileName,
            fileUrl: item.fileUrl,
            jobDescriptionId: item.jobDescriptionId,
            jobGradeCode: item.jobGradeCode,
            jobGrade: item.jobGrade,
            fromDate: item?.fromDate,
            toDate: item?.toDate,
          }))
        );
      } else {
        const filtered = GradeandGradeCodes.filter(
          (item) => item.jobgradecode === selectedGrade
        );

        setFilteredJobDescriptions(
          filtered.map((item) => ({
            jobGradeCode: item.jobgradecode,
            jobGrade: item.jobgrade,
          }))
        );
      }
    } catch (error) {
      setFilteredJobDescriptions([]);
    }
  };

  // ...existing code...
  const validateJobDescriptions = () => {
    let isValid = true;
    let missingRow = null;
    data.forEach((row, idx) => {
      // Only validate for primary role (assuming roleType === "Primary")
      if (
        row.roleType === "Primary" &&
        (!addedJobDescriptions[row.key] ||
          !addedJobDescriptions[row.key].fileName)
      ) {
        isValid = false;
        missingRow = idx + 1;
      }
    });
    if (!isValid) {
      message.error(
        `Please select a job description for row ${missingRow} (Primary Role).`
      );
    }
    return isValid;
  };
  // ...existing code...

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop: async (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        const reader = new FileReader();
        reader.onload = async (e) => {
          const base64 = e.target.result;
          const type = file.type; // or set your own category/type
          // Call your function here
          await handlePostCategoryDoc(currentRoleRecord, file, base64, type);
        };
        reader.readAsDataURL(file);
      }
    },
  });

  const handlePostCategoryDoc = async (row, file, base64, type) => {
    const desc = filteredJobDescriptions;
    const jobGradeCode = desc[0]?.jobGradeCode;
    const jobGrade = desc[0]?.jobGrade;
    // const gradeCode = gradeMap[row.key];   // grab the grade you saved earlier

    if (!jobGradeCode || !jobGrade) {
      message.warning("No jobGradeCode or gradeCode found for this row.");
      return;
    }

    setViewLoading(true);
    try {
      const token = window.localStorage.getItem("token") || "";

      const body = {
        clientid: "",
        engagementid: "",
        method: "appraisalInformation",
        jobgradecode: jobGradeCode || "",
        jobgrade: jobGrade || "",
        category: type || "",
        filename: file?.name || "",
        attachmenttype: file?.type || "",
        description: "-",
        content: base64 || "",
        createdby: userInfo?.userid || "",
        updatedby: userInfo?.userid || "",
      };

      const response = await axios.post(
        "https://ozwcklfzkf.execute-api.ap-south-1.amazonaws.com/Prod/insyts/engagement/category-doc",
        body,
        { headers: { Insytsjwt: token } }
      );

      if (response.data.response.code === "SUCCESS") {
        const fileData = response.data.response.response;
        const updatedFile = {
          ...fileData,
          name: fileData?.fileName,
        };

        form.setFieldValue("file", [updatedFile]);
      }
    } catch (error) {
      message.error("Error fetching category document.");
    } finally {
      setViewLoading(false);
    }
  };

  // Process accepted files
  acceptedFiles.forEach(async (file) => {
    const reader = new FileReader();
    reader.onload = async function (e) {
      if (
        includes(
          [
            "image/jpeg",
            "image/jpg",
            "image/jpeg",
            "image/png",
            "image/tif",
            "image/tiff",
            "png",
            "jpg",
            "tif",
          ],
          get(file, "type", "")
        )
      ) {
        setFileName(file.path);
        setProfileUploaded(true);
        setUniqueId(generateUniqueId());
        const userId = form.getFieldValue("user_id");
        const splitUserId = userId.split("@");
        const userIdWithoutDomain = splitUserId[0];
        const updatedUserId = userIdWithoutDomain + uniqueId;
        const { code } = await CALL_API(`profile-upload/${ClientId}`, "post", {
          userid: updatedUserId,
          filetype: get(file, "type", ""),
          content: e.target.result,
          filename: uniqueId,
          emailid: "",
        });
        if (code === STATUS_CODE.SUCCESS) {
          setStoreId(uniqueId);
        }
      } else {
        setProfileUploaded(false);
        message.error("Please upload a valid image file.");
      }
    };
    reader.readAsDataURL(file);
  });

  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
  };

  //Note:  Email Id Validation required in future
  const validateEmail = (rule, value) => {
    if (value && emailList.includes(value.trim())) {
      return Promise.reject("This Email is already registered");
    }
    return Promise.resolve();
  };

  const rolecolumns = [
    {
      title: "Role Name",
      dataIndex: "roleName",
      key: "roleName",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "roleId",
      key: "roleId",
      width: "10%",
      align: "center",
      render: (roleId) => {
        return (
          <Switch
            size="small"
            checked={selectAllRoleChecked || selectedRoleId.includes(roleId)}
            onChange={(checked) => getRoleId(roleId, checked)}
          />
        );
      },
    },
  ];

  const baseLocationColumn = [
    {
      title: "Select Base Location",
      dataIndex: "location_name",
      key: "location_name",
      width: "10%",
    },
    {
      title: "",
      dataIndex: "location_id",
      key: "location_id",
      width: "10%",
      align: "center",
      render: (location_id) => {
        return (
          <Switch
            size="small"
            checked={baseLocation === location_id}
            onChange={(checked) => setBaseLocation(checked ? location_id : "")}
          />
        );
      },
    },
  ];

  const getRoleId = (role_id) => {
    setSelectedRoleId(role_id);
  };

  const handleSelectAllRole = (e) => {
    const checked = e.target.checked;
    setSelectAllRoleChecked(checked);
    const allRoleIds = roleList.map((item) => item.roleId);
    setSelectedRoleId(checked ? allRoleIds : []);
  };

  const stepdata = [
    { id: 1, title: "" },
    { id: 2, title: "" },
    { id: 3, title: "" },
    { id: 4, title: "" },
    { id: 5, title: "" },
    { id: 6, title: "" },
  ];

  //appraisal Information

  const appraisers = userList?.map((item) => item?.fullname); // Example appraisers
  const roleLevels = ["Leader", "Backstop", "Member"];

  // const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    if (isModalVisible) {
      setOtherFileList([]);
      setSelectedOption(null);
      form.setFieldsValue({ jobDescription: undefined });
    }
  }, [isModalVisible]);

  const handleValidation = () => {
    const errors = {};
    let isValid = true;

    const excludedKeys = [
      "key",
      "jobdescriptionFileName",
      "jobdescriptionFileUrl",
      "jobDescriptionId",
      "rolelevel",
      "appraisername",
      "appraiserName",
      "fromDate",
      "toDate",
      "otherFile",
    ];

    data.forEach((record) => {
      Object.keys(record).forEach((key) => {
        if (
          !excludedKeys.includes(key) &&
          (record[key] === "" ||
            record[key] === null ||
            record[key] === undefined)
        ) {
          if (!errors[record.key]) {
            errors[record.key] = {};
          }
          errors[record.key][key] = true;
          isValid = false;
        }
      });
    });

    setValidationErrors(errors);

    if (!isValid) {
      message.error("Please fill in all required fields.");
    }

    return isValid;
  };

  // const totalWeightage = data?.reduce(
  //   (sum, record) => sum + (record.weightage || 0),
  //   0
  // );

  const validateTotalWeightage = () => {
    if (totalWeightage !== 100) {
      // message.error(`Total weightage must be exactly 100%. Current total: ${totalWeightage}%`);
      return false;
    }
    return true;
  };

  const levelLocationId = formValues?.levellocationid
    ? String(formValues.levellocationid)
    : null;

  const isLeaveAllowedForLocation = (leave, locationId) => {
    if (!locationId) return true; // fallback safety

    const locIds = leave?.locationId;

    if (!Array.isArray(locIds)) return false;

    return locIds.map(String).includes(String(locationId));
  };

  const leaveAccurals = form.getFieldValue("leaveAccurals") || [];

  const totalSelectableLeaveTypes = leaveCategoryList?.filter((cat) => {
    if (cat?.accrual !== "Yes") return false;
    if (!isLeaveAllowedForLocation(cat, levelLocationId)) return false;
    return true;
  }) || [];

  // const handleAddRow = () => {
  //   const newRow = {
  //     key: data.length + 1,
  //     orgLevel: "Kenya",
  //     areaofwork: "",
  //     subareaofwork: "",
  //     weightage: 0,
  //     roletype: "Primary",
  //     rolelevel: "Leader",
  //     appraiser: "",
  //     appraisal: "Yes",
  //   };
  //   setData([...data, newRow]);
  // };

  // const handleChange = (value, record, field, label) => {
  //   const updatedData = data.map((item) => {
  //     if (item.key === record.key) {
  //       if (field === "appraiser") {
  //         return { ...item, appraiser: value, appraisername: label };
  //       }
  //       if (field === "roletype" && value === "Additional") {
  //         const additionalCount = data.filter((row) =>
  //           row.roletype.startsWith("Additional")
  //         ).length;
  //         return { ...item, [field]: `Additional ${additionalCount + 1}` };
  //       }
  //       return { ...item, [field]: value };
  //     }
  //     return item;
  //   });

  //   setData(updatedData);

  //   // Remove validation errors if any
  //   if (validationErrors[record.key]?.[field]) {
  //     const updatedErrors = { ...validationErrors };
  //     delete updatedErrors[record.key][field];
  //     if (Object.keys(updatedErrors[record.key] || {}).length === 0) {
  //       delete updatedErrors[record.key];
  //     }
  //     setValidationErrors(updatedErrors);
  //   }
  // };

  // const handleNext = () => {
  //   const isFieldsValid = handleValidation();
  //   const isWeightageValid = validateTotalWeightage();

  //   if (isFieldsValid && isWeightageValid) {
  //     message.success("Validation passed!");
  //     // Proceed to the next step
  //     setStep(step + 1);
  //   }
  // };

  const [validationErrors, setValidationErrors] = useState({});
  const totalWeightage = data.reduce(
    (sum, row) =>
      sum + (row.appraisal === "Yes" ? Number(row.weightage || 0) : 0),
    0
  );

  const handleChange = (value, record, field, label) => {
    const updatedData = data.map((item) =>
      item.key === record.key
        ? field === "appraiser"
          ? { ...item, appraiser: value, appraisername: label }
          : field === "appraisal"
            ? {
              ...item,
              appraisal: value,
              weightage: value === "No" ? 0 : item.weightage,
            }
            : field === "roletype" && value === "Additional"
              ? {
                ...item,
                [field]: `Additional ${data.filter((row) => row.roletype?.startsWith("Additional"))
                  .length + 1
                  }`,
              }
              : { ...item, [field]: value }
        : item
    );

    setData(updatedData);
  };

  const getNextRoleType = () => {
    const existing = data.map((row) => row.roletype);
    if (!existing.includes("Additional 1")) return "Additional 1";
    if (!existing.includes("Additional 2")) return "Additional 2";
    return "Additional 3";
  };

  const handleAddRow = () => {
    const primaryRow = data.find((row) => row.roletype === "Primary");
    if (
      !addedJobDescriptions[primaryRow.key] ||
      !addedJobDescriptions[primaryRow.key].fileName
    ) {
      message.error(
        "Please select a job description for the Primary role before adding another."
      );
      return;
    }
    setData((prevData) => [
      ...prevData,
      {
        key: prevData.length + 1,
        orgLevel: "",
        areaofwork: "",
        subareaofwork: "",
        weightage: 0,
        roletype: getNextRoleType(),
        rolelevel: "",
        appraiser: "",
        appraisal: "",
        jobdescriptionFileName: "",
        jobdescriptionFileUrl: "",
      },
    ]);
    form.setFieldValue("file", []);
    setOtherFileList([]);
  };

  const handleDeleteRow = (key) => {
    const rowToDelete = data.find((row) => row.key === key);
    if (rowToDelete?.roletype === "Primary") return;

    const updatedData = data.filter((row) => row.key !== key);
    setData(updatedData);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Country",
      dataIndex: "orgLevel",
      render: (text, record, index) => (
        <Select
          value={record.orgLevel}
          onChange={(value) => handleChange(value, record, "orgLevel")}
          placeholder="Select Org Level"
          options={managingOfficeData}
          disabled={record.roletype === "Primary"}
          style={{
            border: validationErrors[record.key]?.orgLevel
              ? "1px solid red"
              : "",
          }}
          getPopupContainer={() => containerRef.current}
        />
      ),
    },
    {
      title: "Service Line",
      dataIndex: "areaofwork",
      render: (text, record, index) => (
        <Input
          value={record.areaofwork}
          onChange={(e) => handleChange(e.target.value, record, "areaofwork")}
          placeholder="Enter Service Line"
          disabled={record.roletype === "Primary"}
          style={{
            borderColor: validationErrors[record.key]?.areaofwork ? "red" : "",
            //borderRadius:"24px",
          }}
        />
      ),
    },
    {
      title: "Sub Serviceline",
      dataIndex: "subareaofwork",
      render: (text, record, index) => (
        <Input
          value={record.subareaofwork}
          onChange={(e) =>
            handleChange(e.target.value, record, "subareaofwork")
          }
          placeholder="Enter Sub Serviceline"
          disabled={record.roletype === "Primary"}
          style={{
            borderColor: validationErrors[record.key]?.subareaofwork
              ? "red"
              : "",
            // borderRadius:"24px",
          }}
        />
      ),
    },
    {
      title: "Appraiser",
      dataIndex: "appraiser",
      render: (text, record, index) => {
        const appraiserDisplayValue =
          record.roletype === "Primary"
            ? record.appraiserName || ""
            : record.appraisername ||
            userList?.find((val) => val?.userid === record?.aappraiser)
              ?.fullname;
        return (
          <Select
            getPopupContainer={() => containerRef.current}
            value={appraiserDisplayValue}
            onChange={(value, option) =>
              handleChange(value, record, "appraiser", option?.label)
            }
            placeholder="Select Appraiser"
            options={userList
              ?.filter(
                (val) =>
                  !data?.map((item) => item?.appraiser).includes(val?.userid)
              )
              ?.map((a) => ({
                value: a?.userid,
                label: a?.fullname,
              }))}
            disabled={record.roletype === "Primary"}
            style={{
              border: validationErrors[record.key]?.appraiser
                ? "1px solid red"
                : "",
              //borderRadius:"24px",
            }}
          />
        );
      },
    },

    {
      title: "Appraisal",
      dataIndex: "appraisal",
      render: (text, record, index) => (
        <Select
          value={record.appraisal}
          onChange={(value, option) =>
            handleChange(value, record, "appraisal", option?.label)
          }
          placeholder="Select Appraisal"
          options={[
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
          ]}
          getPopupContainer={() => containerRef.current}
        />
      ),
    },
    {
      title: "Weightage(%)",
      dataIndex: "weightage",
      render: (text, record, index) => (
        <Input
          value={record.weightage ?? ""}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*$/.test(value)) {
              handleChange(Number(value), record, "weightage");
            }
          }}
          onKeyDown={(event) => {
            if (
              !/[0-9]/.test(event.key) &&
              event.key !== "Backspace" &&
              event.key !== "Tab"
            ) {
              event.preventDefault();
            }
          }}
          disabled={record.appraisal !== "Yes"}
          style={{
            borderColor:
              record.appraisal === "Yes" && totalWeightage !== 100
                ? "red"
                : validationErrors[record.key]?.weightage
                  ? "red"
                  : "",
            borderRadius: "8px",
          }}
        />
      ),
    },
    {
      title: "Role Type",
      dataIndex: "roletype",
      render: (text, record, index) => (
        <Select
          value={record.roletype}
          onChange={(value) => handleChange(value, record, "roletype")}
          placeholder="Select Role Type"
          disabled={true}
          suffixIcon={null}
          style={{
            border: validationErrors[record.key]?.roletype
              ? "1px solid red"
              : "",
            //borderRadius:"24px",
          }}
          getPopupContainer={() => containerRef.current}
        >
          <Option value="Primary">Primary</Option>
          <Option value="Additional">Additional</Option>
        </Select>
      ),
    },
    {
      title: "Job Description",
      dataIndex: "jobdescription",
      render: (_, record) => {
        const added = addedJobDescriptions[record.key];
        const jobDescId = added?.jobDescriptionId || record.jobDescriptionId;

        const currentGrade = form.getFieldValue("grade");
        const originalGrade = gradeMap[record.key];
        const showAdd =
          !added ||
          currentGrade !== originalGrade ||
          !record.jobdescriptionFileName;
        if (!showAdd) {
          return (
            <span
              style={{
                cursor: "pointer",
                color: "#1890ff",
                display: "flex",
                alignItems: "center",
                gap: 4,
              }}
              onClick={() => handleViewJobDescription(record)}
            // onClick={() => window.open(record.jobdescriptionFileUrl, "_blank")}
            >
              <EyeOutlined style={{ fontSize: 16 }} />
              <span style={{ textDecoration: "underline" }}>View</span>
            </span>
          );
        }
        return (
          <span
            className="text-primary"
            style={{ cursor: "pointer", color: "black" }}
          >
            <span>
              <button
                type="button"
                onClick={async (e) => {
                  e.stopPropagation();
                  setAddLoadingRow(record.key);
                  setOtherFileList([]);
                  setSelectedOption(null);
                  form.setFieldsValue({ jobDescription: undefined });
                  setAddLoadingRow(record.key);

                  setCurrentRoleRecord(record);
                  const grade = form.getFieldValue("grade");
                  if (!grade) {
                    message.warning(
                      "Please select a Grade before adding a Job Description."
                    );
                    setAddLoadingRow(null);
                    return;
                  }

                  setGradeMap((prev) => ({ ...prev, [record.key]: grade })); // Save grade
                  setModalLoading(true);
                  setOtherFileList([]);
                  setSelectedOption(null);
                  form.setFieldsValue({ jobDescription: undefined });
                  await fetchJobDescriptions();
                  setIsModalVisible(true);
                  setModalLoading(false);
                  setAddLoadingRow(null);
                }}
                style={{
                  color: "black",
                  outline: "none",
                  boxShadow: "none",
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                }}
              >
                +
                <span style={{ textDecoration: "underline", marginLeft: 4 }}>
                  Add
                </span>
                {addLoadingRow === record.key && <CircleLoader />}
              </button>
            </span>
          </span>
        );
      },
    },
    {
      title: "",
      dataIndex: "actions",
      render: (_, record) =>
        record.roletype !== "Primary" && (
          <DeleteIcon
            onClick={() => handleDeleteRow(record.key)}
            style={{ color: "red", cursor: "pointer" }}
          />
        ),
    },
  ];

  const handleFormValuesChange = (changedValues, allValues) => {
    // Dynamically handle changes in the form values
    if (changedValues.professionalcertifications) {
      const updatedCertifications = allValues.professionalcertifications || [];
      updatedCertifications.forEach((cert, index) => {
        if (cert.certificationtype !== "Others") {
          form.setFieldValue(
            ["professionalcertifications", index, "certificationname"],
            undefined
          );
        }
      });
    }
  };
  useEffect(() => {
    let fullname = `${formValues?.firstname} ${formValues?.lastname}`;
    let baselocationname = filteredLocation?.find(
      (item) => item?.location_id == formValues?.levellocationid
    );
    form.setFieldsValue({ role_id: fullname || "-" });
    form.setFieldsValue({
      baselocationid: baselocationname?.location_name || "-",
    });
  }, [formValues]);

  console.log("leaveCategoryList", leaveCategoryList);

  useEffect(() => {
    if (step === 4) {
      setFormValues((prev) => ({
        ...prev,
        appraisalData: data,
      }));
    }
  }, [data, step]);
  const s = [
    {
      key: "1",
      roleType: "Appraiser",
      change: "Updated Goals",
      modifiedBy: "John Doe",
    },
    {
      key: "2",
      roleType: "Reviewer",
      change: "Submitted Review",
      modifiedBy: "Jane Smith",
    },
  ];

  const historyColumns = [
    {
      title: "Role Type",
      dataIndex: "roleType",
      key: "roleType",
    },
    {
      title: "Change",
      dataIndex: "change",
      key: "change",
    },
    {
      title: "Modified By",
      dataIndex: "modifiedBy",
      key: "modifiedBy",
    },
  ];

  const handleDeleteClick = () => {
    Modal.confirm({
      title: "Are you sure you want to delete this job description?",
      okText: "Yes",
      okType: "primary",
      cancelText: "No",
      centered: true,
      onOk() {
        const updatedData = data.map((item) => {
          if (item.key === currentRoleRecord?.key) {
            return {
              ...item,
              jobdescriptionFileName: "",
              jobDescriptionId: "",
              jobdescriptionFileUrl: "",
            };
          }
          return item;
        });

        setData(updatedData);
        setIsPdfModalVisible(false);
      },
    });
  };

  const handleShowHistoryModal = () => {
    setIsHistory(true);
    setIsModalVisible(true);
    // Optional: trigger API call for history here if needed
  };

  const selectedCountry = Form.useWatch("managingoffice", form);
  const subClusterEnabled = Form.useWatch("subCluster", form);
  const selectedSubClusters = Form.useWatch("subClusterList", form) || [];
  const selectedSupervisorId = Form.useWatch("officesupervisor", form);

  const normalizeCountry = (val) => {
    if (!val) return "";
    if (Array.isArray(val)) val = val[0];
    if (typeof val === "object") return val.value || val.label || "";
    return val;
  };

  const primaryCountry = normalizeCountry(selectedCountry);
  const loggedInCountry = userInfo?.managingoffice?.[0];

  const allowedCountries = React.useMemo(() => {
    if (primaryCountry === "Head Office") return ["Head Office"];
    const base = primaryCountry || loggedInCountry;
    const subClusters = subClusterEnabled
      ? selectedSubClusters.map(normalizeCountry)
      : [];
    return [...new Set([base, ...subClusters].filter(Boolean))];
  }, [primaryCountry, loggedInCountry, subClusterEnabled, selectedSubClusters]);

  const officeSupervisorOptions = React.useMemo(() => {
    if (!supervisorList?.length) return [];
    if (allowedCountries.includes("Head Office")) {
      return supervisorList;
    }
    let filtered = supervisorList.filter((sup) => {
      //  const empCountryCode = sup.employeeId
      //    ?.split("-")?.[1]
      //    ?.toUpperCase();

      //  const empFullCountry = empCountryCode ? countryNameToCode[empCountryCode] : null;

      //  const countryMatch = empCountryCode && allowedCountries.some((c) => {
      //    const upperC = c.toUpperCase();
      //    if (upperC.startsWith(empCountryCode)) return true;
      //    if (empFullCountry && c === empFullCountry) return true;
      //    return false;
      //  });

      const userDetails = userList?.find(
        (u) => u.userid === sup.userid && u.statusid === "1"
      );
      const useridCountryMatch = userDetails?.managingoffice?.some((office) =>
        allowedCountries.includes(office)
      );
      const subClusterMatch =
        userDetails?.subcluster === true &&
        userDetails?.subclustercountries?.some((c) =>
          allowedCountries.includes(c)
        );

      return useridCountryMatch || subClusterMatch;
    });

    return filtered;
  }, [supervisorList, userList, allowedCountries, selectedSupervisorId]);

  useEffect(() => {
    if (!selectedSupervisorId) return;

    const stillExists = officeSupervisorOptions.some(
      (opt) => opt.employeeId === selectedSupervisorId
    );

    if (!stillExists) {
      form.setFieldValue("officesupervisor", undefined);
    }
  }, [officeSupervisorOptions, selectedSupervisorId, form]);

  useEffect(() => {
    if (!subClusterEnabled) return;
    if (!primaryCountry || primaryCountry === "Head Office") return;

    const currentList = form.getFieldValue("subClusterList") || [];

    // Remove primary country if it exists elsewhere and add it to the front
    const others = currentList.filter(c => c !== primaryCountry);

    if (!currentList.includes(primaryCountry) || currentList[0] !== primaryCountry) {
      form.setFieldValue("subClusterList", [primaryCountry, ...others]);
    }
  }, [primaryCountry, subClusterEnabled, form]);
  return (
    <>
      <Modal
        open={isPdfModalVisible}
        title={
          <div className="d-flex justify-content-between">
            <h6>Job Description Preview</h6>
            <div
              className="mx-4"
              style={{ cursor: "pointer" }}
              onClick={handleDeleteClick}
            >
              <TrashDelete className="table_action_icon" /> Delete
            </div>
          </div>
        }
        footer={null}
        onCancel={() => setIsPdfModalVisible(false)}
        width={800}
        bodyStyle={{ height: "80vh", padding: 0 }}
      >
        {pdfUrl ? (
          <iframe
            src={pdfUrl}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title="PDF Preview"
          />
        ) : (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Spin size="large" />
          </div>
        )}
      </Modal>

      {modalLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Spin size="large" />
        </div>
      )}
      {isEmpty(selectedDetails) && (
        <>
          <label
            className="bg-transparent border-0 mb-3 text-left styled-cursor"
            onClick={() => closeModal(false)}
          >
            Employee <ArrowForwardIosIcon className="px-1" />
          </label>{" "}
          <b className=" pb-0 pt-1">Add Employee</b>
        </>
      )}
      <StepsProgress stepdata={stepdata} title="" step={step} />
      {/* <div className="styled-card mb-5"> */}
      {step === 0 && (
        <StyledModal>
          <Form
            className=""
            form={form}
            name="addemployeeform"
            layout="vertical"
            initialValues={{
              firstname: "",
              lastname: "",
              salutation: "",
              othernames: "",
              dateofbirth: "",
              gender: "",
              dependent: "",
              maritalstatus: "",
              phoneno: "",
              user_id: "",
              postaladdress: "",
              physicaladdress: "",
              password: "",
              country: "",
              greetings: "",
              national_id: "",
              nationality: "",
              workpermitno: "",
              workpermitexpirydate: "",
              emergencycontactname: "",
              emergencycontactnumber: "",
              nextofkinrelationship: "",
              nextofkinpostaladdress: "",
              personalemailid: "",
            }}
            onFinish={() => onFinish(1)}
          >
            <b className="my-2 mx-1">Personal Information:</b>
            <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="firstname"
                  label="First Name"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "First name is required",
                    },
                  ]}
                >
                  <Input
                    placeholder="First name"
                    maxLength={50}
                    onKeyDown={(e) => {
                      const allowedChars =
                        /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
                      if (!allowedChars.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="lastname"
                  label="Last Name"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Last name is required",
                    },
                  ]}
                >
                  <Input
                    placeholder="Last name"
                    maxLength={50}
                    onKeyDown={(e) => {
                      const allowedChars =
                        /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
                      if (!allowedChars.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="salutation"
                  label="Salutation"
                  placeholder="Select Salutation"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Salutation is required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Salutation"
                    getPopupContainer={() => containerRef.current}
                  >
                    <Option value="Mr.">Mr.</Option>
                    <Option value="Dr.">Dr.</Option>
                    <Option value="Prof.">Prof.</Option>
                    <Option value="Ms.">Ms.</Option>
                    <Option value="Mrs.">Mrs.</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="othernames"
                  label="Other Names"
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: "Other names is required",
                    },
                  ]}
                >
                  <Input
                    placeholder="Other name"
                    maxLength={50}
                    onKeyDown={(e) => {
                      const allowedChars =
                        /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
                      if (!allowedChars.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  label="Date of Birth"
                  name="dateofbirth"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Date of Birth is required",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format="DD-MM-YYYY"
                    placeholder="Select Date of Birth"
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  name="gender"
                  label="Gender"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Gender is required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select gender"
                    getPopupContainer={() => containerRef.current}
                  >
                    <Option value="male">Male</Option>
                    <Option value="female">Female</Option>
                    <Option value="They/ Them">They/ Them</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12}>
                <Form.Item name="dependent" label="No. of Dependants">
                  <Input
                    placeholder="No. of Dependants"
                    maxLength={10}
                    onKeyDown={(e) => {
                      const value = /^[0-9+]$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9+]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  name="maritalstatus"
                  label="Marital Status"
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select"
                    getPopupContainer={() => containerRef.current}
                  >
                    <Option value="single">Single</Option>
                    <Option value="married">Married</Option>
                    <Option value="widowed">Widowed</Option>
                    <Option value="divorced">Divorced</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12}>
                <Form.Item name="phoneno" label="Mobile Number">
                  <PhoneInput
                    placeholder="Mobile Number"
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value = /^[0-9+]$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9+]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="personalemailid"
                  label="Personal Email ID"
                  rules={[
                    {
                      required: true,
                      pattern: EMAIL_REGEX,
                      message: "Please enter a valid email address",
                    },
                  ]}
                >
                  <Input
                    placeholder="Personal Email ID"
                    maxLength={60}
                  // disabled={!isEmpty(selectedDetails)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="user_id"
                  label="Email address"
                  rules={[
                    {
                      required: true,
                      pattern: EMAIL_REGEX,
                      message: "Email ID is required",
                    },
                    { validator: validateEmployeeId },
                  ]}
                >
                  <Input
                    placeholder="Email ID"
                    maxLength={60}
                    disabled={!isEmpty(selectedDetails)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="postaladdress"
                  label="Postal address"
                  rules={[
                    {
                      required: false,
                      message: "Postal address is required",
                    },
                  ]}
                >
                  <Input
                    placeholder="Postal address"
                    maxLength={60}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9,/]$/.test(e.key) ||
                        /^[a-zA-Z\s,/]+$/.test(e.key);
                      if (!value && e.key !== "Backspace") {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="physicaladdress"
                  label="Physical address"
                  rules={[
                    {
                      required: false,
                      message: "Physical Physical Address is required",
                    },
                  ]}
                >
                  <Input
                    placeholder="Physical address"
                    maxLength={60}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9,/]$/.test(e.key) ||
                        /^[a-zA-Z\s,/]+$/.test(e.key);
                      if (!value && e.key !== "Backspace") {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              {/* <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      validator: (_, value) => {
                        if (value && value.length < 8) {
                          return Promise.reject(
                            "Password should be min 8 to max 15 characters."
                          );
                        } else {
                          return Promise.resolve();
                        }
                      },
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="Password"
                    autoComplete="new-password"
                    maxLength={15}
                  />
                </Form.Item>
              </Col> */}
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  name="country"
                  label="Country"
                  rules={[{ required: false, message: "Country is required" }]}
                >
                  <Select
                    showSearch
                    placeholder="Search to Select"
                    optionFilterProp="children"
                    getPopupContainer={() => containerRef.current}
                  >
                    {countryList?.map((country, index) => (
                      <Select.Option
                        key={index}
                        value={country}
                        label={country}
                      >
                        {country}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  name="greetings"
                  label="Greetings"
                  rules={[
                    { required: false, message: "Greetings is required" },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Search to Select"
                    optionFilterProp="children"
                    getPopupContainer={() => containerRef.current}
                  >
                    {Greetings?.map((value, index) => (
                      <Select.Option key={index} value={value} label={value}>
                        {value}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="national_id"
                  label="National ID/Passport Number"
                >
                  <Input
                    placeholder="National ID/Passport Number"
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  name="nationality"
                  label="Nationality"
                  rules={[
                    { required: false, message: "Nationality is required" },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Search to Select"
                    optionFilterProp="children"
                    getPopupContainer={() => containerRef.current}
                  >
                    {countryList?.map((country, index) => (
                      <Select.Option
                        key={index}
                        value={country}
                        label={country}
                      >
                        {country}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12}>
                <Form.Item name="workpermitno" label="Work Permit No:">
                  <Input
                    placeholder="Work Permit No:"
                    type="text"
                    maxLength={10}
                    onKeyDown={(e) => {
                      const value = /^[0-9]$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  label="Work permit expiry date"
                  name="workpermitexpirydate"
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: "Work permit expiry date is required",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format="DD-MM-YYYY"
                    placeholder="Select Work permit expiry date"
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  label="Role Name"
                  name="roleId"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Please Select",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Role"
                    name="roleId"
                    options={roleOptions}
                    fieldNames={{
                      label: "roleName",
                      value: "roleId",
                    }}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              </Col>

              {/* <Col xs={24} sm={24} md={24}>
                <Form.Item name="profile" label="Profile Pic">
                  <StyledDropzone {...getRootProps()}>
                    <input {...getInputProps()} disabled />
                    <p>
                      {filename !== "" ? <>{filename}</> : <> choose file</>}
                    </p>
                  </StyledDropzone>
                </Form.Item>
              </Col> */}
            </StyleRow>
            <b className="my-2 mx-1">Next Of Kin Details:</b>
            <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="emergencycontactname"
                  label="Emergency Contact Name"
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: "Emergency Contact Name is required",
                    },
                  ]}
                >
                  <Input
                    placeholder="Emergency Contact Name"
                    maxLength={30}
                    onKeyDown={(e) => {
                      const allowedChars = /^[a-zA-Z\s]+$/;
                      if (!allowedChars.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="emergencycontactnumber"
                  label="Emergency Contact Number"
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: "Emergency Contact Number is required",
                    },
                  ]}
                >
                  <PhoneInput
                    placeholder="Emergency Contact Number"
                    maxLength={20}
                    onKeyDown={(e) => {
                      const value = /^[0-9+]$/?.test(e.key);
                      if (!value && e.key !== "Backspace" && /^[0-9+]$/) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nextofkinrelationship"
                  label="Relationship"
                  rules={[
                    {
                      required: false,
                      pattern: NON_EMPTY_REGEX,
                      message: "Relationship is required",
                    },
                  ]}
                >
                  <Input
                    placeholder="Relationship"
                    maxLength={15}
                    onKeyDown={(e) => {
                      const allowedChars = /^[a-zA-Z\s]+$/;
                      if (!allowedChars.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="nextofkinpostaladdress"
                  label="Postal address"
                  rules={[
                    {
                      required: false,
                      message: "Postal address is required",
                    },
                  ]}
                >
                  <Input
                    placeholder="Postal address"
                    maxLength={60}
                    onKeyDown={(e) => {
                      const value =
                        /^[0-9,/]$/.test(e.key) ||
                        /^[a-zA-Z\s,/]+$/.test(e.key);
                      if (!value && e.key !== "Backspace") {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
            </StyleRow>
            <div className="text-end mb-3">
              <StyledButton
                loading={showLoader}
                type="primary"
                htmlType="submit"
              >
                Next
              </StyledButton>
            </div>
          </Form>
        </StyledModal>
      )}
      {/* {step === 1 && (
        <>
          {roleList.length === 0 && (
            <StyledButton className="mt-2" onClick={() => setOpenModal(true)}>
              Add Role
            </StyledButton>
          )}
          {roleList?.length > 0 && (
            <Checkbox
              className="mt-3"
              checked={selectAllRoleChecked}
              onChange={handleSelectAllRole}
            >
              Select All
            </Checkbox>
          )}
          <SelectTable
            step={step}
            setStep={setStep}
            columns={rolecolumns}
            tabledata={roleList}
            editRole="edit"
            selectedRoleId={selectedRoleId}
          />
          <FormModal
            isModalVisible={openModal}
            closeModal={() => setOpenModal(false)}
            Name="Role"
          />
        </>
      )}
      {step === 2 && (
        <SelectTable
          step={step}
          setStep={setStep}
          columns={baseLocationColumn}
          tabledata={locationBasedOnRole}
          editRole="edit"
          selectedBaseLocation={baseLocation}
        />
      )} */}
      {step === 1 && (
        <>
          <StyledModal>
            <Form
              form={form}
              name="dynamic_form_nest_item"
              onFinish={() => onFinish(2)}
              onValuesChange={handleFormValuesChange}
              autoComplete="off"
              initialValues={{
                educationdetails: [
                  {
                    institutename: "",
                    fromdate: "",
                    todate: "",
                    exambody: "",
                    awarded: "",
                    attachment: [],
                  },
                ],
                practicaltrainings: [
                  {
                    organisationname: "",
                    fromdate: "",
                    todate: "",
                    positionheld: "",
                    tasksperformed: "",
                  },
                ],
                professionalcertifications: [
                  {
                    certificationtype: "",
                    certificationname: "",
                    fromdate: "",
                    todate: "",
                    remarks: "",
                    attachment: [],
                  },
                ],
              }}
              labelCol={{ xs: 24, sm: 24, md: 24 }}
              style={{ textAlign: "left" }}
            >
              <b>Education Details:</b>
              <Form.List name="educationdetails">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <StyleRow gutter={16}>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Institute Name"
                            name={[name, "institutename"]}
                            rules={[
                              {
                                required: false,
                                message: "Institute Name required",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Institute Name"
                            // onChange={onFinish}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label="From:"
                            name={[name, "fromdate"]}
                            rules={[
                              { required: false, message: "Date required" },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              // onChange={() => {
                              //   onFinish();
                              // }}
                              placeholder="From"
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label="To:"
                            name={[name, "todate"]}
                            rules={[
                              { required: false, message: "Date required" },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              // onChange={() => {
                              //   onFinish();
                              // }}
                              placeholder="To"
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            {...restField}
                            label="Exam Body:"
                            name={[name, "exambody"]}
                            rules={[
                              {
                                required: false,
                                message: "Exam Body required",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Exam Body"
                            // onChange={onFinish}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            {...restField}
                            label="Awarded:"
                            name={[name, "awarded"]}
                            rules={[
                              { required: false, message: "Awarded required" },
                            ]}
                          >
                            <Select
                              placeholder="Select"
                              getPopupContainer={() => containerRef.current}
                            >
                              <Option value="Doctorate">Doctorate</Option>
                              <Option value="Master">Master</Option>
                              <Option value="Bachelor">Bachelor</Option>
                              <Option value="Diploma">Diploma</Option>
                              <Option value="Certificate">Certificate</Option>
                            </Select>
                          </Form.Item>
                          {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Attachment"
                            name={[name, "attachment"]}
                            valuePropName="fileList"
                            rules={[
                              {
                                required: false,
                                message: "file is required",
                              },
                            ]}
                            getValueFromEvent={(e) => {
                              if (Array.isArray(e)) {
                                return e;
                              }
                              return e && e.fileList;
                            }}
                          >
                            <Upload
                              customRequest={({ file, onSuccess }) => {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);

                                reader.onload = () => {
                                  const base64Data =
                                    reader.result.split(",")[1];
                                  const uniqueId = generateUniqueId();
                                  onSuccess({ file, base64Data, uniqueId });
                                };

                                reader.onerror = (error) => {
                                  console.error("File read error:", error);
                                };
                              }}
                              name="logo"
                              // action="/upload.do"
                              onChange={(value) => {
                                //  onFinish();
                                uploadFile(value);
                              }}
                              onRemove={(file) => {
                                handleFileRemove(file);
                              }}
                              listType="picture"
                              style={{ width: "100%" }}
                            >
                              <div style={{ width: "100%" }}>
                                <Button
                                  className="w-100 text-start"
                                  size="large"
                                >
                                  Upload File
                                </Button>
                              </div>
                            </Upload>
                          </Form.Item>
                        </Col>
                      </StyleRow>
                    ))}
                    <Form.Item>
                      <u
                        className="bg-transparent border-0 text-start"
                        type="dashed"
                        onClick={() => add()}
                        block
                      >
                        +Add Another
                      </u>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <b>Practical Trainings:</b>
              <Form.List name="practicaltrainings">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <StyleRow gutter={16} className="mt-2">
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Organisation Name"
                            name={[name, "organisationname"]}
                            rules={[
                              {
                                required: false,
                                message: "Organisation Name required",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Organisation Name"
                            // onChange={() => {
                            //   onFinish();
                            // }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label="From:"
                            name={[name, "fromdate"]}
                            rules={[
                              { required: false, message: "Date required" },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              // onChange={() => {
                              //   onFinish();
                              // }}
                              placeholder="From"
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label="To:"
                            name={[name, "todate"]}
                            rules={[
                              { required: false, message: "Date required" },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              // onChange={() => {
                              //   onFinish();
                              // }}
                              placeholder="To"
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Position Held"
                            name={[name, "positionheld"]}
                            rules={[
                              {
                                required: false,
                                message: "Position Held required",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Position Held"
                            // onChange={() => {
                            //   onFinish();
                            // }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Nature of work & Tasks performed or completed"
                            name={[name, "tasksperformed"]}
                            rules={[
                              {
                                required: false,
                                message:
                                  "Nature of work & Tasks performed or completed required",
                              },
                            ]}
                          >
                            <Input.TextArea
                              placeholder="Nature of work & Tasks performed or completed"
                            // onChange={() => {
                            //   // onFinish();
                            // }}
                            />
                          </Form.Item>
                          {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                        </Col>
                      </StyleRow>
                    ))}
                    <Form.Item>
                      <u
                        className="bg-transparent border-0 text-start"
                        type="dashed"
                        onClick={() => add()}
                        block
                      >
                        +Add Another
                      </u>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <b>Professional Certifications:</b>
              <Form.List name="professionalcertifications">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <StyleRow gutter={16} className="mt-2">
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Certification Type"
                            name={[name, "certificationtype"]}
                            rules={[
                              {
                                required: false,
                                message: "Certification Type required",
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              placeholder="Select"
                              optionFilterProp="children"
                              getPopupContainer={() => containerRef.current}
                            >
                              {AwardList?.map((value, index) => (
                                <Select.Option
                                  key={index}
                                  value={value}
                                  label={value}
                                >
                                  {value}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        {form.getFieldValue([
                          "professionalcertifications",
                          name,
                          "certificationtype",
                        ]) === "Others" && (
                            <Col xs={24} sm={24} md={24}>
                              <Form.Item
                                {...restField}
                                label="Other Certification Name"
                                name={[name, "certificationname"]}
                                rules={[
                                  {
                                    required: false,
                                    message:
                                      "Please enter Other Certification Name",
                                  },
                                ]}
                              >
                                <Input placeholder="Enter Other Certification Name" />
                              </Form.Item>
                            </Col>
                          )}
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label="From:"
                            name={[name, "fromdate"]}
                            rules={[
                              { required: false, message: "Date required" },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              // onChange={() => {
                              //   onFinish();
                              // }}
                              placeholder="From"
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label="To:"
                            name={[name, "todate"]}
                            rules={[
                              { required: false, message: "Date required" },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              // onChange={() => {
                              //   onFinish();
                              // }}
                              placeholder="To"
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Remarks"
                            name={[name, "remarks"]}
                            rules={[
                              { required: false, message: "Remarks required" },
                            ]}
                          >
                            <Input
                              placeholder="Remarks"
                            // onChange={() => {
                            //   onFinish();
                            // }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Attachment"
                            name={[name, "attachment"]}
                            valuePropName="fileList"
                            rules={[
                              {
                                required: false,
                                message: "file is required",
                              },
                            ]}
                            getValueFromEvent={(e) => {
                              if (Array.isArray(e)) {
                                return e;
                              }
                              return e && e.fileList;
                            }}
                          >
                            <Upload
                              customRequest={({ file, onSuccess }) => {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);

                                reader.onload = () => {
                                  const base64Data =
                                    reader.result.split(",")[1];
                                  const uniqueId = generateUniqueId();
                                  onSuccess({ file, base64Data, uniqueId });
                                };

                                reader.onerror = (error) => {
                                  console.error("File read error:", error);
                                };
                              }}
                              name="logo"
                              // action="/upload.do"
                              onChange={(value) => {
                                //  onFinish();
                                uploadFile(value);
                              }}
                              onRemove={(file) => {
                                handleFileRemove(file);
                              }}
                              listType="picture"
                              style={{ width: "100%" }}
                            >
                              <div style={{ width: "100%" }}>
                                <Button
                                  className="w-100 text-start"
                                  size="large"
                                >
                                  Upload File
                                </Button>
                              </div>
                            </Upload>
                          </Form.Item>
                        </Col>
                      </StyleRow>
                    ))}
                    <Form.Item>
                      <u
                        className="bg-transparent border-0 text-start"
                        type="dashed"
                        onClick={() => add()}
                        block
                      >
                        +Add Another
                      </u>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <div className="text-end mb-3">
                <StyledButton type="primary" onClick={() => setStep(step - 1)}>
                  Back
                </StyledButton>
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  Next
                </StyledButton>
              </div>
            </Form>
          </StyledModal>
        </>
      )}
      {step === 2 && (
        <>
          <StyledModal>
            <Form
              className=""
              form={form}
              name="addemployeeidentityform"
              layout="vertical"
              initialValues={{
                workexperience: [
                  {
                    companyname: "",
                    fromdate: "",
                    todate: "",
                    jobtitle: "",
                    relevnt: "",
                    jobdescription: "",
                  },
                ],
              }}
              onFinish={() => onFinish(3)}
            >
              <b>Work Experience:</b>
              <Form.List name="workexperience">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <StyleRow gutter={16} className="mt-2">
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            {...restField}
                            label="Company name"
                            name={[name, "companyname"]}
                            rules={[
                              {
                                required: false,
                                message: "Company name required",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Company name"
                            // onChange={() => {
                            //   onFinish();
                            // }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            {...restField}
                            label="Job Title"
                            name={[name, "jobtitle"]}
                            rules={[
                              {
                                required: false,
                                message: "Job Title required",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Job Title"
                            // onChange={() => {
                            //   onFinish();
                            // }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label="From:"
                            name={[name, "fromdate"]}
                            rules={[
                              { required: false, message: "Date required" },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              // onChange={() => {
                              //   onFinish();
                              // }}
                              placeholder="From"
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label="To:"
                            name={[name, "todate"]}
                            rules={[
                              { required: false, message: "Date required" },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              // onChange={() => {
                              //   onFinish();
                              // }}
                              placeholder="To"
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Relevant"
                            name={[name, "relevant"]}
                            rules={[
                              { required: false, message: "Relevant required" },
                            ]}
                          >
                            <Select
                              placeholder="Select"
                              getPopupContainer={() => containerRef.current}
                            // onChange={onFinish}
                            >
                              <Option value="yes">Yes</Option>
                              <Option value="no">No</Option>
                            </Select>
                          </Form.Item>
                          {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Job Description"
                            name={[name, "jobdescription"]}
                            rules={[
                              {
                                required: false,
                                message: "Job Description required",
                              },
                            ]}
                          >
                            <Input.TextArea
                              placeholder="Job Description"
                            // onChange={() => {
                            //   onFinish();
                            // }}
                            />
                          </Form.Item>
                          {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                        </Col>
                      </StyleRow>
                    ))}
                    <Form.Item>
                      <u
                        className="bg-transparent border-0 text-start"
                        type="dashed"
                        onClick={() => add()}
                        block
                      >
                        +Add Another
                      </u>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <div className="text-end mb-3">
                <StyledButton type="primary" onClick={() => setStep(step - 1)}>
                  Back
                </StyledButton>
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  Next
                </StyledButton>
              </div>
            </Form>
          </StyledModal>
        </>
      )}
      {step === 3 && (
        <Form
          className=""
          form={form}
          name="addemployeeform"
          layout="vertical"
          initialValues={{
            accountname: "",
            accountno: "",
            bankname: "",
            bankbranch: "",
            bankcountry: "",
            bankcode: "",
            bankbranchcode: "",
            bankswiftcode: "",
            nssf: "",
            krapin: "",
            nhif: "",
            helpmonthlybilling: "",
          }}
          onFinish={() => onFinish(4)}
        >
          <b className="mt-2 mx-1">Banking Information</b>
          <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="accountname"
                label="Account Name"
                rules={[
                  {
                    required: false,
                    message: "Account Name is required",
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="Account Name"
                  // maxLength={500}
                  onKeyDown={(e) => {
                    const allowedChars = /^[a-zA-Z\s]+$/;
                    if (!allowedChars.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="accountno"
                label="Account Number"
                rules={[
                  {
                    required: false,
                    message: "Account Number is required",
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="Account Number"
                  maxLength={25}
                // onKeyDown={(e) => {
                //   const allowedChars = /^[a-zA-Z\s]+$/;
                //   if (!allowedChars.test(e.key)) {
                //     e.preventDefault();
                //   }
                // }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="bankname"
                label="Bank Name"
                rules={[
                  {
                    required: false,
                    message: "Bank Name is required",
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="Bank Name"
                  // maxLength={500}
                  onKeyDown={(e) => {
                    const allowedChars = /^[a-zA-Z\s]+$/;
                    if (!allowedChars.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="bankbranch"
                label="Branch"
                rules={[
                  {
                    required: false,
                    message: "Branch is required",
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="Branch"
                  // maxLength={500}
                  onKeyDown={(e) => {
                    const allowedChars = /^[a-zA-Z\s]+$/;
                    if (!allowedChars.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="bankcountry"
                label="Country"
                rules={[{ required: false, message: "Country is required" }]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  getPopupContainer={() => containerRef.current}
                >
                  {countryList?.map((country, index) => (
                    <Select.Option key={index} value={country} label={country}>
                      {country}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="bankcode"
                label="Bank code"
                rules={[
                  {
                    required: false,
                    message: "Bank code is required",
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="Bank code"
                  maxLength={25}
                // onKeyDown={(e) => {
                //   const allowedChars = /^[a-zA-Z\s]+$/;
                //   if (!allowedChars.test(e.key)) {
                //     e.preventDefault();
                //   }
                // }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="bankbranchcode"
                label="Branch Code"
                rules={[
                  {
                    required: false,
                    message: "Branch Code is required",
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="Branch Code"
                  maxLength={25}
                // onKeyDown={(e) => {
                //   const allowedChars = /^[a-zA-Z\s]+$/;
                //   if (!allowedChars.test(e.key)) {
                //     e.preventDefault();
                //   }
                // }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="bankswiftcode"
                label="Swiftcode"
                rules={[
                  {
                    required: false,
                    message: "Swiftcode is required",
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="Swiftcode"
                  maxLength={25}
                // onKeyDown={(e) => {
                //   const allowedChars = /^[a-zA-Z\s]+$/;
                //   if (!allowedChars.test(e.key)) {
                //     e.preventDefault();
                //   }
                // }}
                />
              </Form.Item>
            </Col>
          </StyleRow>

          <b className="my-2 mx-1">Banking Information</b>
          <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item name="krapin" label="KRA PIN Number">
                <Input
                  placeholder="KRA PIN Number"
                  maxLength={20}
                  onKeyDown={(e) => {
                    const value =
                      /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                    if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item name="nssf" label="NSSF Number">
                <Input
                  placeholder="NSSF Number"
                  maxLength={20}
                  onKeyDown={(e) => {
                    const value =
                      /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                    if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item name="nhif" label="NHIF Number">
                <Input
                  placeholder="NHIF Number"
                  maxLength={20}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="helpmonthlybilling"
                label="HELB monthly billing (KES)"
              >
                <Input
                  placeholder="HELB monthly billing (KES)"
                  maxLength={20}
                  onKeyDown={(e) => {
                    const value =
                      /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                    if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
          </StyleRow>
          <div className="text-end mb-3">
            <StyledButton type="primary" onClick={() => setStep(step - 1)}>
              Back
            </StyledButton>
            <StyledButton loading={showLoader} type="primary" htmlType="submit">
              Next
            </StyledButton>
          </div>
        </Form>
      )}
      {step === 4 && (
        <Form
          className=""
          form={form}
          name="addemployeeform"
          layout="vertical"
          initialValues={{
            managingoffice: [],
            competencyQC: [],
            serviceline: [],
            subserviceline: [],
            leveldepartmentname: [],
            competencyrole: [],
            levellocationid: "",
            supervisor: "",
            companyname: "",
            industry: [],
            secondaryIndustry: [],
            sector: [],
            expertise: "",
            industryrole: [],
            regionalsupervisor: "",
            regionalcompetencyrole: "",
            officesupervisor: "",
            engagementsupervisor: "",
            designation: "",
            grade: "",
            targetchargeability: "",
            chargeoutrate: "",
            lastpromotionlevel: "",
            lastpromotion: "",
            jobtitle: "",
            professionalsince: "",
            hireddate: "",
            employeesponser: "",
            employee_status: "",
            // organisationlevel: [],
          }}
          onFinish={() => {
            if (!validateTotalWeightage()) return;
            if (!validateJobDescriptions()) return;
            if (!handleValidation()) return;
            onFinish(5);
            getSerialNo();
          }}
        >
          <b className="mt-2 mx-1">Level Information:</b>
          <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="managingoffice"
                label="Country"
                rules={[
                  {
                    required: true,
                    message: "Country is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  options={managingOfficeData}
                  fieldNames={{
                    label: "value",
                    value: "value",
                  }}
                  getPopupContainer={() => containerRef.current}
                  onChange={(value) => {
                    setFormValues({
                      ...formValues,
                      managingoffice: value,
                    });
                    setDepartmentLevelData([]);
                    competencyQCfetchData();
                    setDepartmentLevelData([]);

                    const normalize = (str) =>
                      str?.toLowerCase().replace(/\s+/g, " ").trim();

                    const countryLocations = filteredLocation?.filter(
                      (loc) =>
                        normalize(loc.country)?.includes(normalize(value))
                    );

                    // const countryLocations = filteredLocation?.filter(
                    //   (loc) => loc.country?.toLowerCase().trim() === value?.toLowerCase().trim()
                    // );

                    const uniqueLocations = uniqBy(countryLocations, "location_name");

                    if (uniqueLocations?.length > 0) {
                      form.setFieldValue("levellocationid", uniqueLocations[0].location_id);
                    }

                    setFilteredLocationsData(uniqueLocations);

                    // ✅ Update subClusterList when country changes
                    if (form.getFieldValue("subCluster")) {
                      const currentSubClusters = form.getFieldValue("subClusterList") || [];

                      // Remove the old country and keep only additional countries
                      const otherCountries = currentSubClusters.filter(c =>
                        c !== value && // Don't include new country (we'll add it first)
                        managingOfficeData?.some(item => item.value === c) // Keep valid countries
                      );

                      // Set new country first, then others
                      form.setFieldValue("subClusterList", [value, ...otherCountries]);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="competencyQC"
                label="Competency/ QC"
                rules={[
                  {
                    required: true,
                    message: "Competency/ QC is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  mode="multiple"
                  getPopupContainer={() => containerRef.current}
                  disabled={competencyQCData?.length == 0}
                  options={competencyQCData}
                  fieldNames={{
                    label: "value",
                    value: "value",
                  }}
                  onChange={() => {
                    setDepartmentLevelData([]);
                    servicelinefetchData();
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="serviceline"
                label="Service Line"
                rules={[
                  { required: true, message: "Service Line is required" },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  mode="multiple"
                  getPopupContainer={() => containerRef.current}
                  disabled={
                    servicelineData?.length == 0 ||
                    form.getFieldValue("competencyQC")?.length == 0
                  }
                  options={servicelineData}
                  fieldNames={{
                    label: "value",
                    value: "value",
                  }}
                  onChange={(value) => {
                    setFormValues({
                      ...formValues,
                      serviceline: value,
                    });
                    subservicelinefetchData();
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="subserviceline"
                label="Sub-Service Line"
                rules={[
                  {
                    required:
                      subservicelineData && subservicelineData.length > 0,
                    message: "Sub-Service Line is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  mode="multiple"
                  getPopupContainer={() => containerRef.current}
                  disabled={subservicelineData?.length == 0}
                  options={subservicelineData}
                  fieldNames={{
                    label: "value",
                    value: "value",
                  }}
                  onChange={(value) => {
                    setFormValues({
                      ...formValues,
                      subserviceline: value,
                    });
                    departmentfetchData();
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="leveldepartmentname"
                label="Department"
                rules={[
                  {
                    required: true,
                    message: "Department is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  mode="multiple"
                  getPopupContainer={() => containerRef.current}
                  disabled={departmentLevelData?.length == 0}
                  options={departmentLevelData}
                  fieldNames={{
                    label: "value",
                    value: "value",
                  }}
                  onChange={() => {
                    // competencyrolefetchData();
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="competencyrole"
                label="Office Competency Role"
                rules={[
                  {
                    required: false,
                    message: "Office Competency Role is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  mode="multiple"
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  getPopupContainer={() => containerRef.current}
                // onChange={onFinish}
                >
                  {CompetencyRole?.map((value, index) => (
                    <Select.Option key={index} value={value} label={value}>
                      {value}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={12} sm={12} md={3} ref={containerRef}>
              <Form.Item name="subCluster" label="Sub Cluster">
                <Checkbox
                  checked={form.getFieldValue("subCluster")}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setFormValues({
                      ...formValues,
                      subCluster: checked,
                    });
                    form.setFieldValue("subCluster", checked);

                    if (!checked) {
                      form.setFieldValue("subClusterList", []); // Clear selection
                    } else {
                      // ✅ Auto-add selected country when enabling subCluster
                      const currentCountry = form.getFieldValue("managingoffice");
                      if (currentCountry && currentCountry !== "Head Office") {
                        form.setFieldValue("subClusterList", [currentCountry]);
                      }
                    }
                  }}
                />
              </Form.Item>
            </Col>
            {form.getFieldValue("subCluster") && (
              <Col xs={24} sm={24} md={6} ref={containerRef}>
                <Form.Item
                  name="subClusterList"
                  label="Sub Cluster Countries"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (!value || value?.length < 2) {
                          return Promise.reject(
                            new Error("Please select at least two sub cluster countries")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Select
                    mode="multiple"
                    placeholder="Select Sub Cluster Countries"
                    optionFilterProp="children"
                    style={{ width: "100%" }}
                    maxTagCount="responsive"
                    tagRender={(props) => {
                      const { label, value, closable, onClose } = props;
                      const selectedCountry = form.getFieldValue("managingoffice");
                      const isMainCountry = value === selectedCountry;

                      return (
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            padding: "0 7px",
                            marginRight: 3,
                            backgroundColor: isMainCountry ? "#e6f7ff" : "#fafafa",
                            border: "1px solid #d9d9d9",
                            borderRadius: 2,
                            fontSize: 14,
                          }}
                        >
                          {label}
                          {!isMainCountry && closable && (
                            <span
                              onClick={onClose}
                              style={{
                                marginLeft: 5,
                                cursor: "pointer",
                                fontSize: 12,
                              }}
                            >
                              ×
                            </span>
                          )}
                        </span>
                      );
                    }}
                  >
                    {managingOfficeData
                      ?.filter((item) => {
                        const selectedCountry = form.getFieldValue("managingoffice");
                        // ✅ Exclude Head Office AND the currently selected country
                        return item.value !== "Head Office" && item.value !== selectedCountry;
                      })
                      .map((item) => (
                        <Select.Option key={item.value} value={item.value}>
                          {item.value}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            )}


            {/* <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="supervisor"
                label="Supervisor / Manager"
                rules={[
                  {
                    required: false,
                    pattern: NON_EMPTY_REGEX,
                    message: "Supervisor / Manager is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  getPopupContainer={() => containerRef.current}
                  options={supervisorList}
                  fieldNames={{
                    label: "name",
                    value: "employeeId",
                  }}
                  filterOption={(input, option) =>
                    option.name.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col> */}
          </StyleRow>

          <b className="my-2 mx-1">Work Information:</b>
          <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="companyname"
                label="Contracting Company"
                rules={[
                  {
                    required: false,
                    message: "Contracting Company is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  getPopupContainer={() => containerRef.current}
                >
                  {ContractingCompany?.map((value, index) => (
                    <Select.Option key={index} value={value} label={value}>
                      {value}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="industry"
                label="Primary Industry"
                rules={[
                  {
                    required: true,
                    message: "Primary Industry is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  mode="multiple"
                  getPopupContainer={() => containerRef.current}
                >
                  {Industry?.map((value, index) => (
                    <Select.Option key={index} value={value} label={value}>
                      {value}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="secondaryIndustry"
                label="Secondry Industry"
                rules={[
                  {
                    required: false,
                    message: "Secondry Industry is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  mode="multiple"
                  getPopupContainer={() => containerRef.current}
                >
                  {secondaryIndustry?.map((value, index) => (
                    <Select.Option key={index} value={value} label={value}>
                      {value}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col> */}
            {/* <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="sector"
                label="Sector"
                rules={[
                  {
                    required: false,
                    message: "Sector is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  mode="multiple"
                  getPopupContainer={() => containerRef.current}
                >
                  {Sector?.map((value, index) => (
                    <Select.Option key={index} value={value} label={value}>
                      {value}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col> */}
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="expertise"
                label="Expertise"
                rules={[
                  {
                    required: false,
                    message: "Expertise is required",
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="Expertise"
                  // maxLength={500}
                  onKeyDown={(e) => {
                    const allowedChars = /^[a-zA-Z\s]+$/;
                    if (!allowedChars.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="industryrole"
                label="Industry Role"
                rules={[
                  {
                    required: false,
                    message: "Industry Role is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  getPopupContainer={() => containerRef.current}
                >
                  {IndustryRole?.map((value, index) => (
                    <Select.Option key={index} value={value} label={value}>
                      {value}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="regionalsupervisor"
                label="Regional Competency Supervisor"
                rules={[
                  {
                    required: false,
                    message: "Regional Competency Supervisor is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  allowClear
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  getPopupContainer={() => containerRef.current}
                  options={supervisorList}
                  fieldNames={{
                    label: "name",
                    value: "employeeId",
                  }}
                  filterOption={(input, option) =>
                    option.name.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="regionalcompetencyrole"
                label="Regional Competency Role"
                rules={[
                  {
                    required: false,
                    message: "Regional Competency Role is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  getPopupContainer={() => containerRef.current}
                >
                  {RegionalCometencyRole.map((value, index) => (
                    <Select.Option key={index} value={value} label={value}>
                      {value}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="officesupervisor"
                label="Office Competency Supervisor"
                rules={[
                  { required: true, message: "Office Competency Supervisor is required" },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  clearIcon={null}
                  getPopupContainer={triggerNode => triggerNode.parentNode}
                  options={officeSupervisorOptions}
                  fieldNames={{
                    label: "name",
                    value: "employeeId",
                  }}
                  filterOption={(input, option) =>
                    option.name?.toLowerCase()?.includes(input.toLowerCase())
                  }
                  onChange={(value) =>
                    setFormValues({
                      ...formValues,
                      officesupervisorId: value,
                    })
                  }
                />
              </Form.Item>
            </Col>



            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="engagementsupervisor"
                label="Secondary Supervisor"
                rules={[
                  {
                    required: false,
                    message: "Secondary Supervisor is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  getPopupContainer={() => containerRef.current}
                  options={officeSupervisorOptions}
                  fieldNames={{
                    label: "name",
                    value: "employeeId",
                  }}
                  filterOption={(input, option) =>
                    option.name.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="grade"
                label="Grade"
                rules={[{ required: true, message: "Grade is required" }]}
              >
                <Select
                  showSearch
                  placeholder="Select Grade"
                  options={gradeOptions}
                  onChange={(gradeValue) => {
                    const designation = gradeToDesignationMap[gradeValue] || "";
                    form.setFieldsValue({ designation, });
                    setChargeout();
                    setTargetChargeability();
                    setData(prev => prev.map(row => ({ ...row, jobdescriptionFileName: "", jobdescriptionFileUrl: "", })));
                    setAddedJobDescriptions({});
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="designation"
                label="Designation"
              >
                <Input
                  placeholder="Auto-filled based on Grade"
                  disabled
                  style={{
                    backgroundColor: "#f5f5f5",
                    cursor: "not-allowed"
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="chargeoutrate"
                label="Charge Out Rate"
                rules={[
                  {
                    required: false,
                    message: "Charge Out Rate is required",
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="Charge Out Rate"
                  // maxLength={50}
                  onKeyDown={allowOnlyNumbers}
                  disabled={true}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="targetchargeability"
                label="Target Chargeability %"
                rules={[
                  {
                    required: false,
                    message: "Target Chargeability % is required",
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="Target Chargeability %"
                  disabled={true}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                label="Last Promotion Date"
                name="lastpromotionlevel"
                rules={[
                  {
                    required: false,
                    pattern: NON_EMPTY_REGEX,
                    message: "Last Promotion Date is required",
                  },
                ]}
              >
                <DatePicker
                  className="w-100"
                  format="DD-MM-YYYY"
                  placeholder="Select Last Promotion Date"
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="lastpromotion"
                label="Last Promotional Level"
                rules={[
                  {
                    required: false,
                    message: "Last Promotion is required",
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="Last Promotion"
                  maxLength={100}
                // onChange={onFinish}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="jobtitle"
                label="Job Title"
                rules={[
                  {
                    required: false,
                    message: "Job title is required",
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder="Job Title"
                  maxLength={50}
                  onKeyDown={(e) => {
                    const allowedChars = /^[a-zA-Z0-9\s]+$/;
                    if (!allowedChars.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                label="Professional Since"
                name="professionalsince"
                rules={[
                  {
                    required: false,
                    pattern: NON_EMPTY_REGEX,
                    message: "Start date is required",
                  },
                  // () => ({
                  //   // Note : First parameter is Needed
                  //   validator(rule, value) {
                  //     const date = moment(value);
                  //     return date.isValid()
                  //       ? Promise.resolve()
                  //       : Promise.reject();
                  //   },
                  // }),
                ]}
              >
                <DatePicker
                  className="w-100"
                  format="DD-MM-YYYY"
                  onChange={validateDateRange}
                  placeholder="Select start date"
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                label="Hired Date"
                name="hireddate"
                rules={[
                  {
                    required: true,
                    pattern: NON_EMPTY_REGEX,
                    message: "Start date is required",
                  },
                  () => ({
                    // Note : First parameter is Needed
                    validator(rule, value) {
                      const date = moment(value);
                      return date.isValid()
                        ? Promise.resolve()
                        : Promise.reject();
                    },
                  }),
                ]}

              >
                <DatePicker
                  className="w-100"
                  format="DD-MM-YYYY"
                  onChange={validateDateRange}
                  placeholder="Select start date"
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="employeesponser"
                label="Employee Sponsor"
                rules={[
                  {
                    required: true,
                    pattern: NON_EMPTY_REGEX,
                    message: "This field is required",
                  },
                ]}
              >
                <Select
                  placeholder="Select"
                  getPopupContainer={() => containerRef.current}
                >
                  <Option value="yes">Yes</Option>
                  <Option value="no">No</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="employee_status"
                label="Status"
                rules={[
                  {
                    required: true,
                    pattern: NON_EMPTY_REGEX,
                    message: "This field is required",
                  },
                ]}
              >
                <Select
                  placeholder="Select"
                  getPopupContainer={() => containerRef.current}
                  onChange={(value) =>
                    setEmployeeStatusId(value === "active" ? "1" : "0")
                  }
                >
                  <Option value="active">Active</Option>
                  <Option value="in active">In active</Option>
                </Select>
              </Form.Item>
            </Col>
          </StyleRow>
          <Row justify="space-between" align="middle">
            <Col>
              <b className="mt-2 mx-1">Appraisal Information</b>
            </Col>
            {/* <Col
              onClick={handleShowHistoryModal}
              style={{ cursor: "pointer", color: "#1890ff" }}
            >
              History Of Updates
            </Col>{" "} */}
          </Row>

          <Table
            className="mb-3"
            dataSource={data}
            columns={columns}
            pagination={false}
            rowKey="key"
          />
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {totalWeightage > 100 && (
              <div
                className="text-danger"
                style={{
                  marginBottom: 8,
                  marginTop: 0,
                  color: "red",
                  fontWeight: 400,
                  background: "#fff0f0",
                }}
              >
                The total weightage should not exceed 100%
              </div>
            )}
            {totalWeightage < 100 && (
              <div
                className="text-danger"
                style={{
                  marginBottom: 8,
                  marginTop: 0,
                  color: "red",
                  fontWeight: 500,
                  border: "1px solid red",
                  borderRadius: 4,
                  padding: "4px 12px",
                  background: "#fff0f0",
                }}
              >
                The total weightage should not be less than 100%
              </div>
            )}
          </div>
          {data.length < 4 && (
            <span
              className="bg-transparent border-0 text-start"
              type="dashed"
              block
              onClick={handleAddRow}
              style={{
                cursor: "pointer",
                display: "inline-block",
                marginBottom: 16,
              }}
            >
              + <span style={{ textDecoration: "underline" }}>Add Another</span>
            </span>
          )}

          <div className="text-end mb-3">
            <StyledButton type="primary" onClick={() => setStep(step - 1)}>
              Back
            </StyledButton>
            <StyledButton loading={showLoader} type="primary" htmlType="submit">
              Next
            </StyledButton>
          </div>
        </Form>
      )}
      {/* {step === 5 && (
        <Form
          className=""
          form={form}
          name="addemployeeform"
          layout="vertical"
          initialValues={{
            shiftstarttime: "",
            shiftendtime: "",
          }}
          onFinish={() => {
            onFinish(6);
            getSerialNo();
          }}
        >
          <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
            <Col xs={24} sm={24} md={24} ref={containerRef}>
              <Form.Item
                name="role_id"
                label="Select Role:"
                rules={[
                  {
                    required: true,
                    pattern: NON_EMPTY_REGEX,
                    message: "This field is required",
                  },
                ]}
              >
                <Input disabled={true} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} ref={containerRef}>
              <Form.Item
                name="baselocationid"
                label="Select Location"
                rules={[
                  {
                    required: true,
                    pattern: NON_EMPTY_REGEX,
                    message: "This field is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="location_name"
                  options={locationBasedOnRole}
                  fieldNames={{
                    label: "location_name",
                    value: "location_id",
                  }}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="shiftstarttime"
                label="Working Hours (From):"
                rules={[
                  {
                    required: false,
                    pattern: NON_EMPTY_REGEX,
                    message: "This field is required",
                  },
                ]}
              >
              
                <TimePicker format="HH:mm" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                name="shiftendtime"
                label="Working Hours (To):"
                rules={[
                  {
                    required: false,
                    pattern: NON_EMPTY_REGEX,
                    message: "This field is required",
                  },
                ]}
              >
                <TimePicker prefix="To" format="HH:mm" />
              </Form.Item>
            </Col>
          </StyleRow>
          <div className="text-end mb-3">
            <StyledButton type="primary" onClick={() => setStep(step - 1)}>
              Back
            </StyledButton>
            <StyledButton loading={showLoader} type="primary" htmlType="submit">
              Next
            </StyledButton>
          </div>
        </Form>
      )} */}
      {step === 5 && (
        <>
          <h5>Leave Management</h5>
          <StyledModal>
            <Form
              form={form}
              name="leaveForm"
              layout="vertical"
              initialValues={{
                leaveAccurals: [
                  {
                    leave_category_id: "",
                    opening_leaves: "",
                    accrual: "",
                  },
                ],
              }}
              onFinish={() => onFinish(6)}
            >
              <Form.List name="leaveAccurals">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Row gutter={16} className="mt-2" key={key}>
                        {/* Leave Type */}
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            {...restField}
                            label="Leave Type"
                            name={[name, "leave_category_id"]}
                            rules={[
                              {
                                required:
                                  leaveCategoryList?.filter(
                                    (cat) => cat?.accrual === "Yes"
                                    // &&
                                    //   cat?.locationId?.includes(baseLocation)
                                  )?.length > 0
                                    ? true
                                    : false,
                                message: "Leave Type is required",
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              placeholder="Select Leave Type"
                              options={leaveCategoryList
                                ?.filter((cat) => {
                                  // 1. Accrual only
                                  if (cat?.accrual !== "Yes") return false;

                                  // 2. Location-based filtering
                                  if (!isLeaveAllowedForLocation(cat, levelLocationId)) return false;

                                  // 3. Prevent duplicate selection across rows
                                  const alreadySelected = (form.getFieldValue("leaveAccurals") || []).some(
                                    (row, index) =>
                                      row?.leave_category_id === cat.leave_category_id &&
                                      index !== name
                                  );

                                  return !alreadySelected;
                                })
                                .map((it) => ({
                                  label: it.leave_category_name,
                                  value: it.leave_category_id,
                                  __raw: it,
                                }))}
                              onChange={(value) => {
                                const selected = leaveCategoryList.find(
                                  (it) => it.leave_category_id === value
                                );

                                const list = form.getFieldValue("leaveAccurals") || [];
                                const updated = [...list];

                                updated[name] = {
                                  ...(updated[name] || {}),
                                  leave_category_id: value,
                                  openingLeaves: selected?.openingLeaves ?? updated[name]?.openingLeaves,
                                  accrual: selected?.accrual ?? updated[name]?.accrual,
                                  accrualtype: selected?.accrualtype ?? selected?.accrual,
                                  number_of_leaves:
                                    selected?.number_of_leaves ?? updated[name]?.number_of_leaves,
                                };

                                form.setFieldsValue({ leaveAccurals: updated });
                              }}
                            />
                          </Form.Item>
                        </Col>

                        {/* Opening Leave Balance */}
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            {...restField}
                            label="Opening Leave Balance"
                            name={[name, "openingLeaves"]}
                            rules={[
                              {
                                required:
                                  leaveCategoryList?.filter(
                                    (cat) => cat?.accrual === "Yes"
                                    // &&
                                    //   cat?.locationId?.includes(baseLocation)
                                  )?.length > 0
                                    ? true
                                    : false,
                                message: "",
                              },
                              {
                                validator: (_, value) => {
                                  if (
                                    (value === undefined ||
                                      value === null ||
                                      value === "") &&
                                    leaveCategoryList?.filter(
                                      (cat) => cat?.accrual === "Yes"
                                      //  &&
                                      //   cat?.locationId?.includes(
                                      //     baseLocation
                                      //   )
                                    )?.length > 0
                                  ) {
                                    return Promise.reject(
                                      "Please enter your Number of Days"
                                    );
                                  }
                                  if (Number(value) === 0) {
                                    return Promise.reject(
                                      "Please enter your Number of Days greater than zero"
                                    );
                                  }
                                  if (Number(value) >= 200) {
                                    return Promise.reject(
                                      "Please enter your Number of Days less than 200"
                                    );
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <Input
                              maxLength={4}
                              onKeyDown={(e) => {
                                const allowedChars = /^[0-9 .]$/;
                                if (
                                  !allowedChars.test(e.key) &&
                                  e.key !== "Backspace"
                                ) {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>

                        {/* Accrual Applicable (auto) */}
                        <Col xs={24} sm={24} md={6}>
                          <Form.Item
                            {...restField}
                            label="Accrual Applicable"
                            name={[name, "accrual"]}
                          >
                            <Radio.Group>
                              <Radio disabled value="Yes">
                                Yes
                              </Radio>
                              <Radio disabled value="No">
                                No
                              </Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>

                        {/* NEW FIELD 1: Accrual Frequency */}
                        <Col xs={24} sm={24} md={6}>
                          <Form.Item
                            {...restField}
                            label="Accrual Frequency"
                            name={[name, "accrualtype"]}
                          >
                            <Radio.Group disabled>
                              <Radio value="Monthly">Monthly</Radio>
                              <Radio value="Quarterly">Quarterly</Radio>
                              <Radio value="HalfYearly">Half Yearly</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>

                        {/* NEW FIELD 2: Accrual Days */}
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            {...restField}
                            label="Accrual Days"
                            name={[name, "number_of_leaves"]}
                          >
                            <Input maxLength={5} disabled />
                          </Form.Item>
                        </Col>
                        {form.getFieldValue("leaveAccurals").length > 1 && (
                          <Col xs={24}>
                            <div className="w-100 mt-1 text-end">
                              <Button
                                className="mb-2"
                                danger
                                onClick={() => remove(name)}
                              >
                                Remove
                              </Button>
                            </div>
                          </Col>
                        )}
                      </Row>
                    ))}

                    {/* {form.getFieldValue("leaveAccurals").length <
                      leaveCategoryList?.filter(
                        (item) => item?.accrual === "Yes"
                      )?.length && (
                        <Form.Item>
                          <u
                            className="bg-transparent border-0 text-start"
                            type="dashed"
                            onClick={() => add()}
                            block
                            style={{ cursor: "pointer" }}
                          >
                            +Add Another
                          </u>
                        </Form.Item>
                      )} */}
                    {leaveAccurals.length < totalSelectableLeaveTypes.length && (
                      <Form.Item>
                        <u
                          className="bg-transparent border-0 text-start"
                          style={{ cursor: "pointer" }}
                          onClick={() => add()}
                        >
                          + Add Another
                        </u>
                      </Form.Item>
                    )}
                  </>
                )}
              </Form.List>
              <div className="text-end mt-2">
                <StyledButton
                  type="primary"
                  onClick={() => setStep(step - 1)}
                >
                  Back
                </StyledButton>
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  Next
                </StyledButton>
              </div>
            </Form>
          </StyledModal>
        </>
      )}
      {step === 6 && (
        <>
          <Form form={form} onFinish={handlesubmit}>
            <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
              <Col xs={24} sm={24} md={4}>
                User ID:
              </Col>
              <Col xs={24} sm={24} md={20}>
                {formValues?.user_id}
              </Col>
              <Col xs={24} sm={24} md={4}>
                Country:
              </Col>
              <Col xs={24} sm={24} md={20}>
                {formValues?.managingoffice}
              </Col>
              <Col xs={24} sm={24} md={4}>
                Employe serial no.:
              </Col>
              <Col xs={24} sm={24} md={20}>
                {serialNo}
              </Col>
              <Col xs={24} sm={24} md={4}>
                Employee ID:
              </Col>
              <Col xs={24} sm={24} md={20}>
                <b className="text-info">{`EMP000${serialNo}`}</b>
              </Col>
              <Col xs={24} sm={24} md={4}>
                Set Password:
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="password"
                  label=""
                  rules={[
                    {
                      required: true,
                      message: "Password is required",
                    },
                    {
                      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,15}$/,
                      message:
                        "Password must be 8–15 characters, include at least 1 uppercase, 1 lowercase, 1 number, and 1 special character",
                    },
                  ]}

                >
                  <Input.Password
                    placeholder="Password"
                    autoComplete="new-password"
                    maxLength={20}
                  />
                </Form.Item>
              </Col>
            </StyleRow>
            <div className="text-end mb-3">
              <StyledButton
                type="primary"
                onClick={() => {
                  form.resetFields();
                  closeModal(true);
                }}
              >
                Cancel
              </StyledButton>
              <StyledButton type="primary" onClick={() => setStep(step - 1)}>
                Back
              </StyledButton>
              <StyledButton
                loading={showLoader}
                type="primary"
                // onClick={handlesubmit}
                // className="w-30"
                disabled={serialNo === ""}
                htmlType="submit"
              >
                Create
              </StyledButton>
            </div>
          </Form>
        </>
      )}
      {step === 7 && (
        <>
          <InReview
            title="Basic Information"
            setStep={setStep}
            step={step}
            BasicInformation={reviewBasicData}
            role={selectedRoleId}
            // EducationInformation={reviewEducationData}
            baseLocation={baseLocation}
            WorkInformation={reviewWorkData}
            handleCreate={handlesubmit}
            loading={showLoader}
          />
        </>
      )}
      {/* </div> */}

      {isModalVisible && (
        <Modal
          title={isHistory ? "History of Updates" : "Adding Job Description"}
          width={650}
          open={isModalVisible}
          onCancel={onCancel}
          footer={
            !isHistory
              ? [
                <Button
                  key="cancel"
                  style={{
                    width: 130,
                    height: 34,
                    borderRadius: 8,
                    borderWidth: 1,
                  }}
                  onClick={onCancel}
                  modalRender={(modal) => (
                    <div style={{ borderRadius: 8 }}>{modal}</div>
                  )}
                >
                  Cancel
                </Button>,
                <Button
                  key="add"
                  type="primary"
                  onClick={handleFinish}
                  style={{
                    width: 130,
                    height: 34,
                    borderRadius: 8,
                    borderWidth: 1,
                  }}
                  disabled={
                    (selectedOption === null && otherFileList.length === 0) ||
                    viewLoading
                  }
                >
                  Add
                </Button>,
              ]
              : false
          }
        >
          {isHistory ? (
            historyLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: 120,
                }}
              >
                <Spin size="large" />
              </div>
            ) : (
              <Table
                columns={historyColumns}
                dataSource={historyDatas}
                pagination={false}
              />
            )
          ) : modalLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: 120,
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <Form form={form} layout="vertical">
              <Row gutter={20}>
                <Col xs={24} sm={24} md={24} xl={24}>
                  {filteredJobDescriptions.length === 0 ? (
                    <>
                      <div
                        style={{
                          textAlign: "center",
                          // color: "#999",
                          padding: "12px 0",
                        }}
                      >
                        No Data Available
                      </div>
                    </>
                  ) : (
                    <Form.Item name="jobDescription">
                      <div
                        style={{
                          padding: "16px",
                          borderRadius: "8px",
                          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                          maxHeight: "200px",
                          overflowY: "auto",
                        }}
                      >
                        <GreenRadioGroup
                          value={selectedOption}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                          }}
                          onChange={(e) => {
                            setSelectedOption(e.target.value);
                            form.setFieldsValue({
                              jobDescription: e.target.value,
                            });
                            // Clear file upload if radio selected
                            if (
                              form.getFieldValue("file") &&
                              form.getFieldValue("file").length > 0
                            ) {
                              form.setFieldsValue({ file: undefined });
                              message.info(
                                "You can only select one file. Upload cleared."
                              );
                            }
                          }}
                          disabled={
                            !!form.getFieldValue("file") &&
                            form.getFieldValue("file").length > 0
                          }
                        >
                          {filteredJobDescriptions.map((desc) => (
                            <Radio
                              key={desc.jobDescriptionId}
                              value={desc.jobDescriptionId}
                              onClick={() => {
                                if (selectedOption === desc.jobDescriptionId) {
                                  setSelectedOption(null);
                                  form.setFieldsValue({
                                    jobDescription: undefined,
                                  });
                                }
                              }}
                            >
                              {desc.fileName}
                            </Radio>
                          ))}
                        </GreenRadioGroup>
                      </div>
                    </Form.Item>
                  )}
                </Col>
                {currentRoleRecord?.roletype !== "Primary" && (
                  <>
                    <Col xs={24} sm={24} md={24} xl={24}>
                      <Divider plain>or</Divider>
                    </Col>
                    <Col xs={24} sm={24} md={24} xl={24}>
                      <Form.Item
                        name="file"
                        valuePropName="fileList"
                        getValueFromEvent={normFile}
                        help={
                          !!selectedOption &&
                            form.getFieldValue("file") &&
                            form.getFieldValue("file").length > 0
                            ? "You can only select one file. Please remove the uploaded file or deselect the radio option."
                            : ""
                        }
                        validateStatus={
                          !!selectedOption &&
                            form.getFieldValue("file") &&
                            form.getFieldValue("file").length > 0
                            ? "error"
                            : ""
                        }
                      >
                        <Upload
                          name="file"
                          listType="text"
                          maxCount={1}
                          accept=".pdf,.doc,.docx"
                          action=""
                          fileList={otherFileList}
                          beforeUpload={(file) => {
                            if (selectedOption) {
                              message.error(
                                "Please clear your radio selection before uploading another file."
                              );
                              return Upload.LIST_IGNORE;
                            }
                            return true;
                          }}
                          customRequest={handleUpload}
                          onChange={async ({ fileList, file }) => {
                            if (!selectedOption) {
                              setOtherFileList(fileList);
                              if (fileList.length > 0) {
                                const uploadFile = fileList[0].originFileObj;
                                const reader = new FileReader();
                                reader.onload = async (e) => {
                                  const base64 = e.target.result;
                                  await handlePostCategoryDoc(
                                    currentRoleRecord,
                                    uploadFile,
                                    base64,
                                    uploadFile.type
                                  );
                                };
                                reader.readAsDataURL(uploadFile);
                              }
                              if (fileList.length > 0) {
                                setSelectedOption(null);
                                form.setFieldsValue({
                                  jobDescription: undefined,
                                });
                              }
                            }
                          }}
                          onRemove={() => {
                            // let them remove, and simply clear state
                            setOtherFileList([]);
                          }}
                        >
                          <Button
                            icon={<UploadOutlined />}
                            style={{
                              backgroundColor: "#E2E2E8",
                              border: "none",
                              height: "35px",
                              fontWeight: "500",
                              width: "570px",
                            }}
                            disabled={!!selectedOption} // greyed‑out button if a radio is up
                            loading={viewLoading}
                          >
                            Upload Other File
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>
                  </>
                )}
              </Row>
            </Form>
          )}
        </Modal>
      )}

      {showConfirmModal && (
        <Modal
          open={showConfirmModal}
          footer={null}
          closable={false}
          centered
          width={198}
          className="small-close-modal"
          bodyStyle={{
            textAlign: "center",
            padding: 10,
            borderRadius: 8,
            height: 100,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          modalRender={(modal) => (
            <div style={{ borderRadius: 8, overflow: "auto" }}>{modal}</div>
          )}
          onCancel={() => setShowConfirmModal(false)}
        >
          <img
            src={Confirm}
            alt="Confirmed"
            style={{ width: 36, height: 36, marginBottom: 8 }}
          />
          <div
            style={{
              fontWeight: 600,
              fontSize: 18,
              marginBottom: 4,
              marginTop: 4,
            }}
          >
            Added
          </div>
        </Modal>
      )}
    </>
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateUserList: setUserList,
      saveRoleList: setRoleList,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  allDepartmentList: getAllDepartmentList(state),
  locationList: getLocations(state),
  ClientId: getClientid(state),
  leaveCategoryList: getLeaveCategoryList(state),
  roleList: getRoleList(state),
  userList: getUserList(state),
  bandList: getBandList(state),
  supervisorList: getSupervisorList(state),
});

export default connect(mapStateToProps, mapDispatchToProps, null)(AddEmployee);